var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "tab-gathering-trailer" } },
    [
      _c(
        "el-form",
        {
          staticClass: "section",
          staticStyle: {
            "flex-direction": "row",
            width: "fit-content",
            "min-width": "1345px"
          },
          attrs: { disabled: _vm.readonly }
        },
        [
          _c(
            "el-checkbox",
            {
              attrs: { no: "landTransportation" },
              on: {
                change: function($event) {
                  return _vm.pm.loadingTermChange("landTransportation")
                }
              },
              model: {
                value: _vm.form.landTransportation,
                callback: function($$v) {
                  _vm.$set(_vm.form, "landTransportation", $$v)
                },
                expression: "form.landTransportation"
              }
            },
            [_vm._v(_vm._s(_vm.$t("Partners.doorInformation")) + " ")]
          ),
          _c(
            "el-checkbox",
            {
              staticStyle: { "margin-left": "-20px" },
              attrs: { no: "dischargingPortDoor" },
              model: {
                value: _vm.form.dischargingPortDoor,
                callback: function($$v) {
                  _vm.$set(_vm.form, "dischargingPortDoor", $$v)
                },
                expression: "form.dischargingPortDoor"
              }
            },
            [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_DestinationDelivery")) + " ")]
          ),
          _c(
            "el-checkbox",
            {
              staticStyle: { "margin-left": "-20px" },
              attrs: { no: "warehousing" },
              on: {
                change: function($event) {
                  return _vm.pm.loadingTermChange("warehousing")
                }
              },
              model: {
                value: _vm.form.warehousing,
                callback: function($$v) {
                  _vm.$set(_vm.form, "warehousing", $$v)
                },
                expression: "form.warehousing"
              }
            },
            [_vm._v(_vm._s(_vm.$t("SeaExport.WarehouseLoading")) + " ")]
          ),
          _c(
            "el-checkbox",
            {
              staticStyle: { "margin-left": "-20px" },
              attrs: { no: "customs" },
              on: {
                change: function(val) {
                  _vm.form.customsBroker = val ? _vm.form.customsBroker : 0
                  _vm.form.customsDeclarationType = val
                    ? _vm.form.customsDeclarationType
                    : -1
                }
              },
              model: {
                value: _vm.form.customs,
                callback: function($$v) {
                  _vm.$set(_vm.form, "customs", $$v)
                },
                expression: "form.customs"
              }
            },
            [_vm._v(_vm._s(_vm.$t("SeaExport.CustomsDeclaration")) + " ")]
          ),
          _c(
            "el-checkbox",
            {
              staticStyle: { "margin-left": "-20px" },
              attrs: { no: "isInsure" },
              model: {
                value: _vm.form.insure,
                callback: function($$v) {
                  _vm.$set(_vm.form, "insure", $$v)
                },
                expression: "form.insure"
              }
            },
            [_vm._v(_vm._s(_vm.$t("SeaExport.InsureInfo")) + " ")]
          ),
          !!_vm.templateName
            ? _c("div", { staticStyle: { "flex-grow": "1" } }, [
                _c(
                  "span",
                  {
                    staticClass: "blue",
                    staticStyle: {
                      float: "right",
                      "margin-right": "30px",
                      padding: "0 5px",
                      "white-space": "nowrap"
                    }
                  },
                  [
                    _vm._v(
                      _vm._s(_vm.$t("CargoMsg.Cargo_SopTemplate")) +
                        ": " +
                        _vm._s(_vm.templateName)
                    )
                  ]
                )
              ])
            : _vm._e()
        ],
        1
      ),
      _c(
        "div",
        { staticStyle: { width: "fit-content" } },
        [
          _c(
            "tab-international-card-base-UICustom-layout",
            {
              attrs: {
                "element-blocks": _vm.elementBlocks,
                disabled: _vm.readonly
              }
            },
            [
              _vm.elementDict.jobNo.viewable
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "jobNo" }, slot: "jobNo" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.jobNo.isRequire ? "blue" : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.jobNo.label
                        },
                        slot: "label"
                      }),
                      _c("el-input", {
                        attrs: { value: _vm.form.jobNo, disabled: true }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.isZY
                ? [
                    _c(
                      "el-form-item",
                      {
                        attrs: { slot: "saleProductCode" },
                        slot: "saleProductCode"
                      },
                      [
                        _c(
                          "span",
                          {
                            staticClass: "blue",
                            attrs: { slot: "label" },
                            slot: "label"
                          },
                          [_vm._v(_vm._s(_vm.$t("SeaExport.AllowSaleProduct")))]
                        ),
                        _c("cargo-advance-select", {
                          attrs: {
                            "select-type":
                              _vm.selectTypeNames.basic_data_AllowSaleProduct,
                            filterable: "",
                            no: "allowSaleProduct",
                            clearable: "",
                            "data-filter-function": function(p) {
                              return p.statusEnabled && p.intergraed
                            },
                            "default-value": _vm.form.saleProductCode || ""
                          },
                          on: {
                            parentCallBack: function(p) {
                              _vm.form.saleProductCode = p.value
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { slot: "fullOrInside" }, slot: "fullOrInside" },
                      [
                        _c(
                          "span",
                          {
                            staticClass: "blue",
                            attrs: { slot: "label" },
                            slot: "label"
                          },
                          [_vm._v(_vm._s(_vm.$t("SeaExport.FullOrInside")))]
                        ),
                        _c("cargo-advance-select", {
                          attrs: {
                            "select-type":
                              _vm.selectTypeNames
                                .local_cache_FullOrInside$FULL_OR_INSIDE,
                            no: "fullOrInside",
                            clearable: "",
                            "default-value": _vm.form.fullOrInside || ""
                          },
                          on: {
                            parentCallBack: function(p) {
                              _vm.form.fullOrInside = p.value
                            }
                          }
                        })
                      ],
                      1
                    )
                  ]
                : _vm._e(),
              _vm.elementDict.customerId.viewable
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "customerId" }, slot: "customerId" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.customerId.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.customerId.label
                        },
                        slot: "label"
                      }),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "align-items": "center"
                          }
                        },
                        [
                          _c(
                            "el-tooltip",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.sopImageB,
                                  expression: "sopImageB"
                                }
                              ],
                              attrs: {
                                content: _vm.$t("SeaExport.SOPReceiver"),
                                placement: "right-end"
                              }
                            },
                            [
                              _c("img", {
                                class:
                                  _vm.form.customerId && _vm.readonly
                                    ? ""
                                    : "not-click",
                                staticStyle: {
                                  padding: "5px 0",
                                  "vertical-align": "bottom",
                                  cursor: "pointer"
                                },
                                attrs: {
                                  src: _vm.sopPic,
                                  width: "18",
                                  height: "28"
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.pm.sopChangeCustomerIdHandler()
                                  }
                                }
                              })
                            ]
                          ),
                          _c(
                            "el-tooltip",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.showWarningImageB,
                                  expression: "showWarningImageB"
                                }
                              ],
                              attrs: {
                                content: _vm.warningImageBTip,
                                placement: "right-end"
                              }
                            },
                            [
                              _c("i", {
                                staticClass: "el-icon-warning red",
                                staticStyle: { cursor: "pointer" }
                              })
                            ]
                          ),
                          _c("cargo-sales-company-select", {
                            staticClass: "shipper-selector",
                            staticStyle: { flex: "1" },
                            attrs: {
                              no: "customerId",
                              "popper-class": "shipper-selector-popper",
                              "method-params": {
                                customer: true,
                                active: true,
                                companyLob: "integratedJob"
                              },
                              "check-credit": true,
                              "default-value": _vm.form.customerId || "",
                              disabled:
                                !_vm.customerEnabled ||
                                !_vm.elementDict.customerId.writable,
                              job: _vm.form
                            },
                            on: {
                              parentCallBack: function(p) {
                                _vm.customerIdChange2ContractHandler(p)
                                _vm.clearPoNo()
                              }
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.customerLevel.viewable
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "customerLevel" }, slot: "customerLevel" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.customerLevel.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.customerLevel.label
                        },
                        slot: "label"
                      }),
                      _c(
                        "el-tooltip",
                        {
                          attrs: {
                            content: _vm.customerTip,
                            placement: "bottom"
                          }
                        },
                        [
                          _c(
                            "span",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value:
                                    (_vm.contractStatus === 2 &&
                                      typeof _vm.customerLevel.level ===
                                        "number") ||
                                    parseInt(_vm.customerLevel.level) > -1,
                                  expression:
                                    "(contractStatus===2&&typeof customerLevel.level==='number')||parseInt(customerLevel.level)>-1"
                                }
                              ],
                              staticClass: "orange"
                            },
                            [_vm._v("LV" + _vm._s(_vm.customerLevel.level))]
                          ),
                          _c(
                            "span",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value:
                                    (_vm.contractStatus === 2 &&
                                      typeof _vm.customerLevel.level ===
                                        "number") ||
                                    parseInt(_vm.customerLevel.level) > -1,
                                  expression:
                                    "(contractStatus===2&&typeof customerLevel.level==='number')||parseInt(customerLevel.level)>-1"
                                }
                              ],
                              staticStyle: { color: "#D3A73B" }
                            },
                            [
                              _vm._v(
                                " " + _vm._s(_vm.customerLevel.customerName)
                              )
                            ]
                          ),
                          _c(
                            "span",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.contractStatusLabel,
                                  expression: "contractStatusLabel"
                                }
                              ],
                              staticClass: "red"
                            },
                            [
                              _vm._v(
                                " (" + _vm._s(_vm.contractStatusLabel) + ")"
                              )
                            ]
                          ),
                          _c(
                            "span",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.advancePaymentLabel,
                                  expression: "advancePaymentLabel"
                                }
                              ],
                              staticStyle: { color: "brown" }
                            },
                            [
                              _vm._v(
                                " (" + _vm._s(_vm.advancePaymentLabel) + ")"
                              )
                            ]
                          ),
                          _c(
                            "span",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value:
                                    _vm.stampPictureView.businessDocuments
                                      .length > 0,
                                  expression:
                                    "stampPictureView.businessDocuments.length > 0"
                                }
                              ],
                              on: {
                                click: function($event) {
                                  _vm.stampPictureView.visible = true
                                }
                              }
                            },
                            [
                              _c("img", {
                                staticStyle: { "text-align": "right" },
                                attrs: {
                                  title: _vm.$t("Message.BookingSeal"),
                                  src: _vm.stampIcon,
                                  height: "14"
                                }
                              })
                            ]
                          )
                        ]
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.customerContact.viewable
                ? _c(
                    "el-form-item",
                    {
                      attrs: { slot: "customerContact" },
                      slot: "customerContact"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.customerContact.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.customerContact.label
                        },
                        slot: "label"
                      }),
                      _c(
                        "div",
                        { staticStyle: { display: "flex" } },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: {
                                no: "customerContact",
                                filterable: "",
                                disabled: !_vm.elementDict.customerContact
                                  .writable,
                                "allow-create": true
                              },
                              model: {
                                value: _vm.form.customerContact,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "customerContact", $$v)
                                },
                                expression: "form.customerContact"
                              }
                            },
                            _vm._l(_vm.contactList, function(item, index) {
                              return _c("el-option", {
                                key: index,
                                attrs: {
                                  label: item.contactPerson,
                                  value: item.contactPerson
                                }
                              })
                            }),
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-link",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: !_vm.isShowContactPersonDetail,
                                  expression: "!isShowContactPersonDetail"
                                }
                              ],
                              class: _vm.form.customerContact
                                ? ""
                                : "not-click",
                              attrs: { no: "customerContactLink" },
                              on: { click: _vm.showContactDialog }
                            },
                            [_vm._v(_vm._s(_vm.$t("SeaExport.Detail")) + " ")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.cargoType.viewable
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "cargoType" }, slot: "cargoType" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.cargoType.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.cargoType.label
                        },
                        slot: "label"
                      }),
                      _c("cargo-advance-select", {
                        attrs: {
                          no: "cargoType",
                          "select-type":
                            _vm.selectTypeNames.basic_data_CargoType,
                          "method-params": { sea: true },
                          filterable: "",
                          clearable: false,
                          disabled: !_vm.elementDict.cargoType.writable,
                          "default-value": _vm.form.cargoType
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.form.cargoType = p.value
                          }
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.salesChannel.viewable
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "salesChannel" }, slot: "salesChannel" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.salesChannel.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.salesChannel.label
                        },
                        slot: "label"
                      }),
                      _c("el-input", {
                        attrs: { value: _vm.form.salesChannel, disabled: true }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.trustFromJob.viewable
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "trustFromJob" }, slot: "trustFromJob" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.trustFromJob.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.trustFromJob.label
                        },
                        slot: "label"
                      }),
                      _c("el-input", {
                        attrs: { value: _vm.form.trustFromJob, disabled: true }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.containerLoadType.viewable
                ? _c(
                    "el-form-item",
                    {
                      attrs: { slot: "containerLoadType" },
                      slot: "containerLoadType"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.containerLoadType.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.containerLoadType.label
                        },
                        slot: "label"
                      }),
                      _c(
                        "el-select",
                        {
                          attrs: {
                            value: _vm.form.containerLoadType,
                            no: "containerLoadType",
                            disabled:
                              _vm.isSelectDisabled ||
                              _vm.hasMaster ||
                              !_vm.elementDict.containerLoadType.writable
                          },
                          on: {
                            change: function(val) {
                              _vm.pm.containerLoadTypeChange(val)
                            }
                          }
                        },
                        _vm._l(_vm.containerLoadTypes, function(item, index) {
                          return _c("el-option", {
                            key: index,
                            attrs: {
                              label: _vm.isZh
                                ? item.chineseName
                                : item.englishName,
                              value: item.code
                            }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.operateType.viewable
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "operateType" }, slot: "operateType" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.operateType.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.operateType.label
                        },
                        slot: "label"
                      }),
                      _c(
                        "el-select",
                        {
                          attrs: {
                            value: _vm.form.operateType,
                            disabled:
                              _vm.hasMaster ||
                              !_vm.elementDict.operateType.writable,
                            no: "operateType"
                          },
                          on: {
                            change: function(val) {
                              _vm.pm.operateTypeChange(val)
                            }
                          }
                        },
                        _vm._l(_vm.operateTypes, function(item, index) {
                          return _c("el-option", {
                            key: index,
                            attrs: {
                              label: _vm.isZh
                                ? item.chineseName
                                : item.englishName,
                              value: item.code
                            }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.transportType.viewable
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "transportType" }, slot: "transportType" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.transportType.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.transportType.label
                        },
                        slot: "label"
                      }),
                      _c("cargo-advance-select", {
                        attrs: {
                          no: "cargoType",
                          "select-type":
                            _vm.selectTypeNames.basic_data_TransportType,
                          "method-params": { ie: true },
                          filterable: "",
                          clearable: false,
                          "default-value": _vm.form.transportType,
                          disabled: !_vm.elementDict.transportType.writable
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.form.transportType = p.value
                          }
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.businessDate.viewable
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "businessDate" }, slot: "businessDate" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.businessDate.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.businessDate.label
                        },
                        slot: "label"
                      }),
                      _c(
                        "div",
                        { staticStyle: { display: "flex" } },
                        [
                          _c("el-date-picker", {
                            staticClass: "departure-date-picker",
                            staticStyle: { flex: "1", "margin-right": "5px" },
                            attrs: {
                              no: "businessDate",
                              value: _vm.form.businessDate,
                              disabled: !_vm.elementDict.businessDate.writable,
                              type: "date",
                              "value-format": "yyyy-MM-dd"
                            },
                            on: { input: _vm.businessDateChange }
                          }),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm._f("filterWeek")(_vm.form.businessDateDay)
                              )
                            )
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.etd.viewable
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "etd" }, slot: "etd" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.etd.isRequire ? "blue" : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.etd.label
                        },
                        slot: "label"
                      }),
                      _c(
                        "div",
                        { staticStyle: { display: "flex" } },
                        [
                          _c("el-date-picker", {
                            staticClass: "departure-date-picker",
                            staticStyle: { flex: "1", "margin-right": "5px" },
                            attrs: {
                              no: "etd",
                              value: _vm.form.etd,
                              disabled:
                                _vm.hasMaster || !_vm.elementDict.etd.writable,
                              type: "date",
                              "value-format": "yyyy-MM-dd"
                            },
                            on: { input: _vm.etdChange }
                          }),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(
                              _vm._s(_vm._f("filterWeek")(_vm.form.sailingDay))
                            )
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.atd.viewable
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "atd" }, slot: "atd" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.atd.isRequire ? "blue" : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.atd.label
                        },
                        slot: "label"
                      }),
                      _c(
                        "div",
                        { staticStyle: { display: "flex" } },
                        [
                          _c("el-date-picker", {
                            staticStyle: { flex: "1", "margin-right": "5px" },
                            attrs: {
                              value: _vm.form.atd,
                              disabled:
                                _vm.hasMaster || !_vm.elementDict.atd.writable,
                              no: "atd",
                              type: "date",
                              "value-format": "yyyy-MM-dd"
                            },
                            on: { input: _vm.atdChange }
                          }),
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm._f("filterWeek")(_vm.form.atdSailingDay)
                              )
                            )
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.eta.viewable
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "eta" }, slot: "eta" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.eta.isRequire ? "blue" : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.eta.label
                        },
                        slot: "label"
                      }),
                      _c(
                        "div",
                        { staticStyle: { display: "flex" } },
                        [
                          _c("el-date-picker", {
                            staticStyle: { flex: "1", "margin-right": "5px" },
                            attrs: {
                              disabled:
                                _vm.hasMaster || !_vm.elementDict.eta.writable,
                              no: "eta",
                              type: "date",
                              "value-format": "yyyy-MM-dd"
                            },
                            on: { input: _vm.etaChange },
                            model: {
                              value: _vm.form.eta,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "eta", $$v)
                              },
                              expression: "form.eta"
                            }
                          }),
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm._f("filterWeek")(_vm.form.etaSailingDay)
                              )
                            )
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.ata.viewable
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "ata" }, slot: "ata" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.ata.isRequire ? "blue" : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.ata.label
                        },
                        slot: "label"
                      }),
                      _c(
                        "div",
                        { staticStyle: { display: "flex" } },
                        [
                          _c("el-date-picker", {
                            staticStyle: { flex: "1", "margin-right": "5px" },
                            attrs: {
                              disabled:
                                _vm.hasMaster || !_vm.elementDict.ata.writable,
                              no: "ata",
                              type: "date",
                              "value-format": "yyyy-MM-dd"
                            },
                            on: { input: _vm.ataChange },
                            model: {
                              value: _vm.form.ata,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "ata", $$v)
                              },
                              expression: "form.ata"
                            }
                          }),
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm._f("filterWeek")(_vm.form.ataSailingDay)
                              )
                            )
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.customsDate.viewable
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "customsDate" }, slot: "customsDate" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.customsDate.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.customsDate.label
                        },
                        slot: "label"
                      }),
                      _c("el-date-picker", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          disabled: !_vm.elementDict.customsDate.writable,
                          no: "customsDate",
                          type: "date",
                          "value-format": "yyyy-MM-dd"
                        },
                        model: {
                          value: _vm.form.customsDate,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "customsDate", $$v)
                          },
                          expression: "form.customsDate"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.dispatchingPlaceCode.viewable
                ? _c(
                    "el-form-item",
                    {
                      attrs: { slot: "dispatchingPlaceCode" },
                      slot: "dispatchingPlaceCode"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.dispatchingPlaceCode.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.dispatchingPlaceCode.label
                        },
                        slot: "label"
                      }),
                      _c("cargo-advance-select", {
                        staticStyle: { flex: "1" },
                        attrs: {
                          no: "dispatchingPlaceCode",
                          "select-type": _vm.selectTypeNames.basic_data_Seaport,
                          placeholder: _vm.$t("SeaExport.PlaceHolderPOR"),
                          disabled: !_vm.elementDict.dispatchingPlaceCode
                            .writable,
                          filterable: "",
                          "default-value": _vm.form.dispatchingPlaceCode,
                          "tag-name": "englishName"
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.pm.changeDispatchingPlaceCode(p)
                          }
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.dispatchingPlace.viewable
                ? _c(
                    "el-form-item",
                    {
                      attrs: { slot: "dispatchingPlace" },
                      slot: "dispatchingPlace"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.dispatchingPlace.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.dispatchingPlace.label
                        },
                        slot: "label"
                      }),
                      _c("el-input", {
                        attrs: {
                          disabled: !_vm.elementDict.dispatchingPlace.writable,
                          no: "dispatchingPlace"
                        },
                        on: {
                          change: function($event) {
                            return _vm.pm.changeDispatchingPlace()
                          }
                        },
                        model: {
                          value: _vm.form.dispatchingPlace,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "dispatchingPlace", $$v)
                          },
                          expression: "form.dispatchingPlace"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.loadingPortCode.viewable
                ? _c(
                    "el-form-item",
                    {
                      attrs: { slot: "loadingPortCode" },
                      slot: "loadingPortCode"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.loadingPortCode.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.loadingPortCode.label
                        },
                        slot: "label"
                      }),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "justify-content": "space-between"
                          }
                        },
                        [
                          _c("cargo-advance-select", {
                            ref: "loadingPortCode",
                            staticStyle: { flex: "1" },
                            attrs: {
                              no: "loadingPortCode",
                              "select-type":
                                _vm.selectTypeNames.basic_data_Seaport,
                              disabled:
                                _vm.hasMaster ||
                                !_vm.elementDict.loadingPortCode.writable,
                              filterable: "",
                              "default-value": _vm.form.loadingPortCode,
                              "tag-name": "englishName"
                            },
                            on: {
                              parentCallBack: function(p) {
                                _vm.loadingPortCodeCharge(p)
                                _vm.pm.setPlannerChange()
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "el-checkbox",
                            {
                              staticStyle: { "padding-left": "2px" },
                              attrs: {
                                disabled:
                                  _vm.hasMaster ||
                                  !_vm.elementDict.loadingPortCode.writable,
                                no: "transfering"
                              },
                              model: {
                                value: _vm.form.transfering,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "transfering", $$v)
                                },
                                expression: "form.transfering"
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("SeaExport.Transit")))]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.transferPortCode.viewable && _vm.form.transfering
                ? _c(
                    "el-form-item",
                    {
                      attrs: { slot: "transferPortCode" },
                      slot: "transferPortCode"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.transferPortCode.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.transferPortCode.label
                        },
                        slot: "label"
                      }),
                      _c("cargo-advance-select", {
                        attrs: {
                          no: "transferPortCode",
                          "select-type": _vm.selectTypeNames.basic_data_Seaport,
                          disabled:
                            _vm.hasMaster ||
                            !_vm.elementDict.transferPortCode.writable,
                          filterable: "",
                          "default-value": _vm.form.transferPortCode
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.form.transferPortCode = p.value
                          }
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.dischargingPortCode.viewable
                ? _c(
                    "el-form-item",
                    {
                      attrs: { slot: "dischargingPortCode" },
                      slot: "dischargingPortCode"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.dischargingPortCode.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.dischargingPortCode.label
                        },
                        slot: "label"
                      }),
                      _c("cargo-advance-select", {
                        attrs: {
                          no: "dischargingPortCode",
                          "select-type": _vm.selectTypeNames.basic_data_Seaport,
                          disabled:
                            _vm.hasMaster ||
                            !_vm.elementDict.dischargingPortCode.writable,
                          filterable: "",
                          "default-value": _vm.form.dischargingPortCode
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.form.dischargingPortCode = p.value
                            _vm.pm.dischargingPortCodeChange(p.value)
                          }
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.waybillDestination.viewable
                ? _c(
                    "el-form-item",
                    {
                      attrs: { slot: "waybillDestination" },
                      slot: "waybillDestination"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.waybillDestination.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.waybillDestination.label
                        },
                        slot: "label"
                      }),
                      _c("el-input", {
                        attrs: {
                          no: "waybillDestination",
                          type: "textarea",
                          disabled:
                            _vm.hasMaster ||
                            !_vm.elementDict.waybillDestination.writable,
                          rows: 5
                        },
                        on: {
                          change: function($event) {
                            return _vm.pm.changeDispatchingPlace()
                          }
                        },
                        model: {
                          value: _vm.form.waybillDestination,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "waybillDestination", $$v)
                          },
                          expression: "form.waybillDestination"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.carrierId.viewable
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "carrierId" }, slot: "carrierId" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.carrierId.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.carrierId.label
                        },
                        slot: "label"
                      }),
                      _c("cargo-company-select", {
                        attrs: {
                          no: "carrierId",
                          disabled:
                            !_vm.carrierIdEnabled ||
                            _vm.hasMaster ||
                            !_vm.elementDict.carrierId.writable,
                          "method-params": {
                            truckCmp: true,
                            active: true,
                            companyLob: "integratedJob"
                          },
                          "default-value": _vm.form.carrierId || ""
                        },
                        on: {
                          change: function(p) {
                            _vm.form.carrierId = p.value
                            _vm.onCarrierIdChange()
                          },
                          blur: function($event) {
                            return _vm.pm.carrierFocusOutEventHandler()
                          }
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.polCountry.viewable
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "polCountry" }, slot: "polCountry" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.polCountry.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.polCountry.label
                        },
                        slot: "label"
                      }),
                      _c("el-input", {
                        attrs: { no: "polCountry", disabled: true },
                        model: {
                          value: _vm.form.polCountry,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "polCountry", $$v)
                          },
                          expression: "form.polCountry"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.cargoSource.viewable
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "cargoSource" }, slot: "cargoSource" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.cargoSource.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.cargoSource.label
                        },
                        slot: "label"
                      }),
                      _c(
                        "el-select",
                        {
                          attrs: {
                            no: "cargoSource",
                            disabled:
                              !_vm.cargoSourceEnabled ||
                              !_vm.elementDict.cargoSource.writable,
                            placeholder: _vm.$t("SeaExport.PleaseSelect"),
                            size: "mini"
                          },
                          on: {
                            change: function($event) {
                              _vm.form.designationAgent = 0
                              _vm.pm.cargoSourceChange({
                                fieldName: "cargoSource"
                              })
                            }
                          },
                          model: {
                            value: _vm.form.cargoSource,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "cargoSource", $$v)
                            },
                            expression: "form.cargoSource"
                          }
                        },
                        _vm._l(_vm.CARGO_SOURCES, function(item, index) {
                          return _c("el-option", {
                            key: index,
                            attrs: {
                              label: _vm.isZh
                                ? item.chineseName
                                : item.englishName,
                              value: item.code
                            }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.customJobType.viewable
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "customJobType" }, slot: "customJobType" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.customJobType.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.customJobType.label
                        },
                        slot: "label"
                      }),
                      _c("cargo-advance-select", {
                        ref: "customJobType",
                        attrs: {
                          no: "customJobType",
                          "select-type":
                            _vm.selectTypeNames.basic_data_CutomJobType,
                          filterable: "",
                          disabled: !_vm.elementDict.customJobType.writable,
                          "default-value": _vm.form.customJobType,
                          "method-params": { type: _vm.form.lob },
                          "tag-name": _vm.isZh ? "name" : "englishName",
                          "static-options": _vm.customJobTypeList
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.form.customJobType = p.value
                            _vm.onCustomJobTypeChange()
                            _vm.contractRuleFieldChange(
                              _vm.form.customerId,
                              _vm.form.designationAgent
                            )
                          }
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.secondaryCustomJobType.viewable &&
              _vm.form.customJobType &&
              _vm.secondaryCustomJobTypeList.length > 0
                ? _c(
                    "el-form-item",
                    {
                      attrs: { slot: "secondaryCustomJobType" },
                      slot: "secondaryCustomJobType"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.secondaryCustomJobType.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.secondaryCustomJobType.label
                        },
                        slot: "label"
                      }),
                      _c("cargo-advance-select", {
                        ref: "secondaryCustomJobType",
                        attrs: {
                          no: "secondaryCustomJobType",
                          "select-type":
                            _vm.selectTypeNames.basic_data_CutomJobType,
                          disabled: !_vm.elementDict.secondaryCustomJobType
                            .writable,
                          filterable: "",
                          cache: false,
                          "default-value": _vm.form.secondaryCustomJobType,
                          "tag-name": _vm.isZh ? "name" : "englishName",
                          "static-options": _vm.secondaryCustomJobTypeList
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.form.secondaryCustomJobType = p.value
                          }
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.transportSource.viewable
                ? _c(
                    "el-form-item",
                    {
                      attrs: { slot: "transportSource" },
                      slot: "transportSource"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.transportSource.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.transportSource.label
                        },
                        slot: "label"
                      }),
                      _c("cargo-advance-select", {
                        attrs: {
                          filterable: "",
                          "select-type":
                            _vm.selectTypeNames.basic_data_TransportSource,
                          disabled: !_vm.elementDict.transportSource.writable,
                          no: "transportSource",
                          "default-value": _vm.form.transportSource,
                          cache: false,
                          "tag-value": "code",
                          placeholder: " "
                        },
                        on: {
                          parentCallBack: function(item) {
                            return (_vm.form.transportSource = item.value)
                          }
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.statisticArea.viewable
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "statisticArea" }, slot: "statisticArea" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.statisticArea.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.statisticArea.label
                        },
                        slot: "label"
                      }),
                      _c("cargo-advance-select", {
                        attrs: {
                          filterable: "",
                          "select-type":
                            _vm.selectTypeNames.basic_data_StatisticArea,
                          disabled: !_vm.elementDict.statisticArea.writable,
                          no: "statisticArea",
                          "default-value": _vm.form.statisticArea,
                          cache: false,
                          "tag-value": "code",
                          placeholder: " "
                        },
                        on: {
                          parentCallBack: function(item) {
                            return (_vm.form.statisticArea = item.value)
                          }
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.destinationAgent.viewable
                ? _c(
                    "el-form-item",
                    {
                      attrs: { slot: "destinationAgent" },
                      slot: "destinationAgent"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.destinationAgent.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.destinationAgent.label
                        },
                        slot: "label"
                      }),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "align-items": "center"
                          }
                        },
                        [
                          _c(
                            "el-tooltip",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.sopImageC,
                                  expression: "sopImageC"
                                }
                              ],
                              attrs: {
                                content: _vm.$t("SeaExport.SOPReceiver"),
                                placement: "right-end"
                              }
                            },
                            [
                              _c("img", {
                                class:
                                  _vm.form.destinationAgent && _vm.readonly
                                    ? ""
                                    : "not-click",
                                staticStyle: {
                                  padding: "5px 0",
                                  cursor: "pointer"
                                },
                                attrs: {
                                  src: _vm.sopPic,
                                  width: "18",
                                  height: "28"
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.pm.sopChangeHandler()
                                  }
                                }
                              })
                            ]
                          ),
                          _c(
                            "el-tooltip",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.showWarningImageC,
                                  expression: "showWarningImageC"
                                }
                              ],
                              attrs: {
                                content: _vm.warningImageCTip,
                                placement: "right-end"
                              }
                            },
                            [
                              _c("i", {
                                staticClass: "el-icon-warning red",
                                staticStyle: { cursor: "pointer" }
                              })
                            ]
                          ),
                          _c("cargo-advance-select", {
                            attrs: {
                              no: "destinationAgent",
                              "select-type":
                                _vm.selectTypeNames.basic_data_Company,
                              "method-params": {
                                overseaAgent: true,
                                companyLob: "integratedJob",
                                active: true
                              },
                              "default-value": _vm.form.destinationAgent || "",
                              disabled: !_vm.elementDict.destinationAgent
                                .writable,
                              filterable: "",
                              headers: [_vm.$t("Partners.englishName")],
                              fields: ["englishName"],
                              "tag-name": "englishName"
                            },
                            on: {
                              parentCallBack: function(p) {
                                _vm.pm.txtDestinationAgentChangeHandler(p)
                              }
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.designationAgent.viewable &&
              _vm.form.cargoSource === "NC"
                ? _c(
                    "el-form-item",
                    {
                      attrs: { slot: "designationAgent" },
                      slot: "designationAgent"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.designationAgent.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.designationAgent.label
                        },
                        slot: "label"
                      }),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "align-items": "center"
                          }
                        },
                        [
                          _c(
                            "el-tooltip",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.sopImageA,
                                  expression: "sopImageA"
                                }
                              ],
                              attrs: {
                                content: _vm.$t("SeaExport.SOPReceiver"),
                                placement: "right-end"
                              }
                            },
                            [
                              _c("div", [
                                _c("img", {
                                  class:
                                    _vm.form.designationAgent && _vm.readonly
                                      ? ""
                                      : "not-click",
                                  staticStyle: {
                                    padding: "5px 0",
                                    cursor: "pointer"
                                  },
                                  attrs: {
                                    src: _vm.sopPic,
                                    width: "18",
                                    height: "28"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.pm.sopChangeBookingAgentHandler()
                                    }
                                  }
                                })
                              ])
                            ]
                          ),
                          _c(
                            "el-tooltip",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.showWarningImageA,
                                  expression: "showWarningImageA"
                                }
                              ],
                              attrs: {
                                content: _vm.warningImageATip,
                                placement: "right-end"
                              }
                            },
                            [
                              _c("i", {
                                staticClass: "el-icon-warning red",
                                staticStyle: { cursor: "pointer" }
                              })
                            ]
                          ),
                          _c("cargo-advance-select", {
                            staticClass: "designation-agent-selector",
                            attrs: {
                              no: "designationAgent",
                              "popper-class":
                                "designation-agent-selector-popper",
                              "select-type":
                                _vm.selectTypeNames.basic_data_Company,
                              disabled:
                                !_vm.designationAgentEnabled ||
                                !_vm.elementDict.designationAgent.writable,
                              "method-params": {
                                designationAgent: true,
                                companyLob: "integratedJob",
                                active: true
                              },
                              "check-credit": true,
                              "default-value": _vm.form.designationAgent || "",
                              filterable: "",
                              headers: [_vm.$t("Partners.englishName")],
                              fields: ["englishName"],
                              "tag-name": "englishName"
                            },
                            on: {
                              parentCallBack: function(p) {
                                _vm.pm.designationAgentChangeHandler(p)
                              }
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.bookingAgent.viewable
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "bookingAgent" }, slot: "bookingAgent" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.bookingAgent.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.bookingAgent.label
                        },
                        slot: "label"
                      }),
                      _c("cargo-advance-select", {
                        attrs: {
                          no: "bookingAgent",
                          "select-type": _vm.selectTypeNames.basic_data_Company,
                          "method-params": {
                            bookingAgent: true,
                            companyLob: "integratedJob",
                            active: true
                          },
                          filterable: "",
                          disabled: !_vm.elementDict.bookingAgent.writable,
                          "default-value": _vm.form.bookingAgent || ""
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.form.bookingAgent = p.value
                          }
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.transferAgent.viewable
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "transferAgent" }, slot: "transferAgent" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.transferAgent.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.transferAgent.label
                        },
                        slot: "label"
                      }),
                      _c("cargo-advance-select", {
                        attrs: {
                          no: "transferAgent",
                          "select-type": _vm.selectTypeNames.basic_data_Company,
                          "method-params": {
                            portAgent: true,
                            companyLob: "integratedJob",
                            active: true
                          },
                          filterable: "",
                          disabled: !_vm.elementDict.transferAgent.writable,
                          "default-value": _vm.form.transferAgent || ""
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.form.transferAgent = p.value
                          }
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.customerRefNo.viewable
                ? _c(
                    "el-form-item",
                    {
                      attrs: { slot: "customerRefNo", id: "customerRefNo" },
                      slot: "customerRefNo"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.customerRefNo.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.customerRefNo.label
                        },
                        slot: "label"
                      }),
                      _c(
                        "el-tooltip",
                        {
                          attrs: {
                            disabled: !_vm.customerRefNoTip,
                            content: _vm.customerRefNoTip,
                            placement: "right-end"
                          }
                        },
                        [
                          _c("el-input", {
                            class: _vm.customerRefNoTip ? "red" : "",
                            attrs: {
                              no: "customerRefNo",
                              disabled: !_vm.elementDict.customerRefNo.writable
                            },
                            on: {
                              blur: function($event) {
                                return _vm.pm.customerRefNoFocusOutHandler()
                              }
                            },
                            model: {
                              value: _vm.form.customerRefNo,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "customerRefNo", $$v)
                              },
                              expression: "form.customerRefNo"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.poNo.viewable
                ? _c(
                    "el-form-item",
                    {
                      class: _vm.poNoRed ? "poNoClass" : "",
                      attrs: { slot: "poNo" },
                      slot: "poNo"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.poNo.isRequire ? "blue" : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.poNo.label
                        },
                        slot: "label"
                      }),
                      !_vm.openProjectConfig
                        ? _c("el-input", {
                            attrs: {
                              no: "poNo",
                              disabled: !_vm.elementDict.poNo.writable
                            },
                            model: {
                              value: _vm.form.poNo,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "poNo", $$v)
                              },
                              expression: "form.poNo"
                            }
                          })
                        : _vm._e(),
                      _vm.openProjectConfig
                        ? _c("cargo-project-select", {
                            attrs: {
                              no: "poNo",
                              "default-value": _vm.form.poNo,
                              "customer-id": _vm.form.customerId,
                              "is-linked": _vm.isProjectLinkedCustomer,
                              disabled: !_vm.elementDict.poNo.writable
                            },
                            on: {
                              change: function(p) {
                                _vm.form.poNo = p.value
                                _vm.form.projectName = p.projectName
                                _vm.changeProject()
                              }
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.projectName.viewable && _vm.openProjectConfig
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "projectName" }, slot: "projectName" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.projectName.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.projectName.label
                        },
                        slot: "label"
                      }),
                      _c("el-input", {
                        attrs: { disabled: true },
                        model: {
                          value: _vm.form.projectName,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "projectName", $$v)
                          },
                          expression: "form.projectName"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.projectBatch.viewable && _vm.openProjectConfig
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "projectBatch" }, slot: "projectBatch" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.projectBatch.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.projectBatch.label
                        },
                        slot: "label"
                      }),
                      _c("el-input", {
                        attrs: {
                          no: "projectBatch",
                          disabled: !_vm.elementDict.projectBatch.writable
                        },
                        model: {
                          value: _vm.form.projectBatch,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "projectBatch", $$v)
                          },
                          expression: "form.projectBatch"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.customsBroker.viewable
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "customsBroker" }, slot: "customsBroker" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.customsBroker.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.customsBroker.label
                        },
                        slot: "label"
                      }),
                      _c("cargo-advance-select", {
                        attrs: {
                          no: "customsBroker",
                          disabled:
                            !_vm.customsBrokerEnabled ||
                            !_vm.elementDict.customsBroker.writable,
                          "select-type": _vm.selectTypeNames.basic_data_Company,
                          "data-filter-function": _vm.customsBrokerFilter,
                          filterable: "",
                          "default-value": _vm.form.customsBroker || "",
                          placeholder: !_vm.customsBrokerEnabled
                            ? _vm.$t(
                                "SeaExport.PleaseTickCustomsDeclarationOption"
                              )
                            : _vm.$t("CargoMsg.Cargo_keyWordsTip"),
                          "method-params": {
                            customsBroker: true,
                            companyLob: "integratedJob",
                            active: true
                          }
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.form.customsBroker = p.value
                          }
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.customsDeclarationType.viewable
                ? _c(
                    "el-form-item",
                    {
                      attrs: { slot: "customsDeclarationType" },
                      slot: "customsDeclarationType"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.customsDeclarationType.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.customsDeclarationType.label
                        },
                        slot: "label"
                      }),
                      _c("cargo-advance-select", {
                        attrs: {
                          no: "customsDeclarationType",
                          disabled:
                            !_vm.customsBrokerEnabled ||
                            !_vm.elementDict.customsDeclarationType.writable,
                          "select-type":
                            _vm.selectTypeNames
                              .basic_data_CustomsDeclarationType,
                          filterable: "",
                          "default-value":
                            _vm.form.customsDeclarationType === -1
                              ? ""
                              : _vm.form.customsDeclarationType,
                          placeholder: _vm.$t("CargoMsg.Cargo_keyWordsTip")
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.form.customsDeclarationType = p.value
                          }
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.customsMethodPol.viewable
                ? _c(
                    "el-form-item",
                    {
                      attrs: { slot: "customsMethodPol" },
                      slot: "customsMethodPol"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.customsMethodPol.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.customsMethodPol.label
                        },
                        slot: "label"
                      }),
                      _c("cargo-advance-select", {
                        attrs: {
                          no: "customsMethodPol",
                          disabled:
                            !_vm.customsBrokerEnabled ||
                            !_vm.elementDict.customsMethodPol.writable,
                          "select-type":
                            _vm.selectTypeNames.basic_data_CustomsMode,
                          "method-params": { serviceType: 2 },
                          filterable: "",
                          clearable: false,
                          "default-value": _vm.form.customsMethodPol
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.form.customsMethodPol = p.value
                          }
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.tradeTerm.viewable
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "tradeTerm" }, slot: "tradeTerm" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.tradeTerm.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.tradeTerm.label
                        },
                        slot: "label"
                      }),
                      _c("cargo-advance-select", {
                        attrs: {
                          no: "tradeTerm",
                          "select-type":
                            _vm.selectTypeNames.basic_data_TradeTerm,
                          disabled: !_vm.elementDict.tradeTerm.writable,
                          filterable: "",
                          "default-value": _vm.form.tradeTerm
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.form.tradeTerm = p.value
                          }
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.carryingCmp.viewable
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "carryingCmp" }, slot: "carryingCmp" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.carryingCmp.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.carryingCmp.label
                        },
                        slot: "label"
                      }),
                      _c("cargo-company-select", {
                        attrs: {
                          no: "carryingCmp",
                          disabled:
                            !_vm.form.landTransportation ||
                            !_vm.elementDict.carryingCmp.writable,
                          "method-params": {
                            truckCmp: true,
                            active: true,
                            companyLob: "integratedJob"
                          },
                          "default-value": _vm.form.carryingCmp || "",
                          placeholder: !_vm.form.landTransportation
                            ? _vm.$t(
                                "SeaExport.PleaseTickDoorLoadingDeliveryOption"
                              )
                            : _vm.$t("CargoMsg.Cargo_keyWordsTip")
                        },
                        on: {
                          change: function(p) {
                            _vm.pm.carryingCmpChangeHandler(p)
                          }
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.warehouseCmp.viewable
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "warehouseCmp" }, slot: "warehouseCmp" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.warehouseCmp.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.warehouseCmp.label
                        },
                        slot: "label"
                      }),
                      _c("cargo-company-select", {
                        attrs: {
                          no: "warehouseCmp",
                          disabled:
                            !_vm.warehouseEabled ||
                            !_vm.elementDict.warehouseCmp.writable,
                          "method-params": {
                            warehouse: true,
                            active: true,
                            companyLob: "integratedJob"
                          },
                          "default-value": _vm.form.warehouseCmp || "",
                          placeholder: !_vm.warehouseEabled
                            ? _vm.$t("SeaExport.PleaseSelectWarehouse")
                            : _vm.$t("CargoMsg.Cargo_keyWordsTip")
                        },
                        on: {
                          change: function(p) {
                            _vm.pm.warehouseCmpChangeHandler(p)
                          }
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.warehouseName.viewable && _vm.openWarehouse
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "warehouseName" }, slot: "warehouseName" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.warehouseName.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.warehouseName.label
                        },
                        slot: "label"
                      }),
                      _c(
                        "el-select",
                        {
                          ref: "warehouseName",
                          attrs: {
                            no: "warehouseName",
                            disabled:
                              !_vm.warehouseEabled ||
                              !_vm.form.warehouseCmp ||
                              !_vm.elementDict.warehouseName.writable,
                            "allow-create": true,
                            filterable: "",
                            clearable: true
                          },
                          on: { change: _vm.warehouseNameChangeHandler },
                          model: {
                            value: _vm.form.warehouseName,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "warehouseName", $$v)
                            },
                            expression: "form.warehouseName"
                          }
                        },
                        _vm._l(_vm.warehouseNameList, function(item, index) {
                          return _c("el-option", {
                            key: index,
                            attrs: {
                              label: item.warehouseName,
                              value: item.warehouseName
                            }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.salePriceRemarks.viewable
                ? _c(
                    "el-form-item",
                    {
                      attrs: { slot: "salePriceRemarks" },
                      slot: "salePriceRemarks"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.salePriceRemarks.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.salePriceRemarks.label
                        },
                        slot: "label"
                      }),
                      _c("el-input", {
                        attrs: {
                          no: "salePriceRemarks",
                          disabled: !_vm.elementDict.salePriceRemarks.writable
                        },
                        model: {
                          value: _vm.form.salePriceRemarks,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "salePriceRemarks", $$v)
                          },
                          expression: "form.salePriceRemarks"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.freeDemurrage.viewable
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "freeDemurrage" }, slot: "freeDemurrage" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.freeDemurrage.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.freeDemurrage.label
                        },
                        slot: "label"
                      }),
                      _c("el-input", {
                        attrs: {
                          no: "freeDemurrage",
                          disabled: !_vm.elementDict.freeDemurrage.writable
                        },
                        model: {
                          value: _vm.form.freeDemurrage,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "freeDemurrage", $$v)
                          },
                          expression: "form.freeDemurrage"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.freeDetention.viewable
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "freeDetention" }, slot: "freeDetention" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.freeDetention.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.freeDetention.label
                        },
                        slot: "label"
                      }),
                      _c("el-input", {
                        attrs: {
                          no: "freeDetention",
                          disabled: !_vm.elementDict.freeDetention.writable
                        },
                        model: {
                          value: _vm.form.freeDetention,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "freeDetention", $$v)
                          },
                          expression: "form.freeDetention"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.customsAreaApplication.viewable
                ? _c(
                    "el-form-item",
                    {
                      attrs: { slot: "customsAreaApplication" },
                      slot: "customsAreaApplication"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.customsAreaApplication.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.customsAreaApplication.label
                        },
                        slot: "label"
                      }),
                      _c("el-input", {
                        attrs: {
                          no: "customsAreaApplication",
                          disabled: !_vm.elementDict.customsAreaApplication
                            .writable
                        },
                        model: {
                          value: _vm.form.customsAreaApplication,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "customsAreaApplication", $$v)
                          },
                          expression: "form.customsAreaApplication"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.incoTerm.viewable
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "incoTerm" }, slot: "incoTerm" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.incoTerm.isRequire ? "blue" : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.incoTerm.label
                        },
                        slot: "label"
                      }),
                      _c("cargo-advance-select", {
                        attrs: {
                          no: "incoTerm",
                          "select-type":
                            _vm.selectTypeNames.basic_data_IncoTerm,
                          disabled: !_vm.elementDict.incoTerm.writable,
                          filterable: "",
                          clearable: false,
                          "default-value": _vm.form.incoTerm
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.form.incoTerm = p.value
                          }
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.paymentTermMBL.viewable
                ? _c(
                    "el-form-item",
                    {
                      attrs: { slot: "paymentTermMBL" },
                      slot: "paymentTermMBL"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.paymentTermMBL.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.paymentTermMBL.label
                        },
                        slot: "label"
                      }),
                      _c("cargo-advance-select", {
                        attrs: {
                          no: "paymentTermMBL",
                          "select-type":
                            _vm.selectTypeNames.basic_data_PaymentTerm,
                          disabled: !_vm.elementDict.paymentTermMBL.writable,
                          filterable: "",
                          clearable: false,
                          "default-value": _vm.form.paymentTermMBL
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.form.paymentTermMBL = p.value
                          }
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.userDefinedField1.viewable
                ? _c(
                    "el-form-item",
                    {
                      attrs: { slot: "userDefinedField1" },
                      slot: "userDefinedField1"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.userDefinedField1.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.userDefinedField1.label
                        },
                        slot: "label"
                      }),
                      _c("el-input", {
                        attrs: {
                          disabled: !_vm.elementDict.userDefinedField1.writable,
                          no: "userDefinedField1",
                          type: "textarea",
                          rows: 5
                        },
                        model: {
                          value: _vm.form.userDefinedField1,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "userDefinedField1", $$v)
                          },
                          expression: "form.userDefinedField1"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.userDefinedField2.viewable
                ? _c(
                    "el-form-item",
                    {
                      attrs: { slot: "userDefinedField2" },
                      slot: "userDefinedField2"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.userDefinedField2.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.userDefinedField2.label
                        },
                        slot: "label"
                      }),
                      _c("el-input", {
                        attrs: {
                          disabled: !_vm.elementDict.userDefinedField2.writable,
                          no: "userDefinedField2",
                          type: "textarea",
                          rows: 5
                        },
                        model: {
                          value: _vm.form.userDefinedField2,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "userDefinedField2", $$v)
                          },
                          expression: "form.userDefinedField2"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.userDefinedField3.viewable
                ? _c(
                    "el-form-item",
                    {
                      attrs: { slot: "userDefinedField3" },
                      slot: "userDefinedField3"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.userDefinedField3.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.userDefinedField3.label
                        },
                        slot: "label"
                      }),
                      _c("el-input", {
                        attrs: {
                          disabled: !_vm.elementDict.userDefinedField3.writable,
                          no: "userDefinedField3",
                          type: "textarea",
                          rows: 5
                        },
                        model: {
                          value: _vm.form.userDefinedField3,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "userDefinedField3", $$v)
                          },
                          expression: "form.userDefinedField3"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.userDefinedField4.viewable
                ? _c(
                    "el-form-item",
                    {
                      attrs: { slot: "userDefinedField4" },
                      slot: "userDefinedField4"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.userDefinedField4.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.userDefinedField4.label
                        },
                        slot: "label"
                      }),
                      _c("el-input", {
                        attrs: {
                          disabled: !_vm.elementDict.userDefinedField4.writable,
                          no: "userDefinedField4",
                          type: "textarea",
                          rows: 5
                        },
                        model: {
                          value: _vm.form.userDefinedField4,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "userDefinedField4", $$v)
                          },
                          expression: "form.userDefinedField4"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.exportControlledProduct &&
              _vm.elementDict.exportControlledProduct.masterVisible
                ? _c(
                    "el-form-item",
                    {
                      attrs: { slot: "exportControlledProduct" },
                      slot: "exportControlledProduct"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.exportControlledProduct.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.exportControlledProduct.label
                        },
                        slot: "label"
                      }),
                      _c(
                        "el-select",
                        {
                          attrs: {
                            no: "exportControlledProduct",
                            disabled:
                              _vm.readonly ||
                              !_vm.elementDict.exportControlledProduct.writable,
                            placeholder: "",
                            clearable: true,
                            size: "mini"
                          },
                          model: {
                            value: _vm.form.exportControlledProduct,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "exportControlledProduct", $$v)
                            },
                            expression: "form.exportControlledProduct"
                          }
                        },
                        _vm._l(_vm.EXPORT_CONTROLLED_PRODUCT, function(
                          item,
                          index
                        ) {
                          return _c("el-option", {
                            key: index,
                            attrs: {
                              label: _vm.isZh
                                ? item.chineseName
                                : item.englishName,
                              value: item.code
                            }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.taxNature.viewable
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "taxNature" }, slot: "taxNature" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.taxNature.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.taxNature.label
                        },
                        slot: "label"
                      }),
                      _c(
                        "el-select",
                        {
                          attrs: {
                            no: "taxNature",
                            placeholder: _vm.$t("SeaExport.PleaseSelect"),
                            disabled: !_vm.elementDict.taxNature.writable,
                            size: "mini"
                          },
                          model: {
                            value: _vm.form.taxNature,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "taxNature", $$v)
                            },
                            expression: "form.taxNature"
                          }
                        },
                        _vm._l(_vm.TAX_NATURES, function(item, index) {
                          return _c("el-option", {
                            key: index,
                            attrs: {
                              label: _vm.isZh
                                ? item.chineseName
                                : item.englishName,
                              value: item.code
                            }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.quantityContract.viewable
                ? _c(
                    "el-form-item",
                    {
                      attrs: { slot: "quantityContract" },
                      slot: "quantityContract"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.quantityContract.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.quantityContract.label
                        },
                        slot: "label"
                      }),
                      _c(
                        "div",
                        { staticStyle: { display: "flex" } },
                        [
                          _c("auto-number-input", {
                            attrs: {
                              no: "quantityContract",
                              disabled: !_vm.elementDict.quantityContract
                                .writable,
                              precision: 0,
                              min: 0
                            },
                            on: {
                              change: function($event) {
                                return _vm.pm.jobContractQwcChange(1)
                              }
                            },
                            model: {
                              value: _vm.form.quantityContract,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "quantityContract", $$v)
                              },
                              expression: "form.quantityContract"
                            }
                          }),
                          _c("span", { staticStyle: { padding: "0 2px" } }, [
                            _vm._v("/")
                          ]),
                          _c("auto-number-input", {
                            ref: "quantityActual",
                            attrs: {
                              no: "quantityActual",
                              precision: 0,
                              disabled:
                                _vm.pm.billChargeFlag ||
                                !_vm.elementDict.quantityContract.writable,
                              min: 0
                            },
                            on: { change: _vm.quantityActualChange },
                            model: {
                              value: _vm.form.quantityActual,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "quantityActual", $$v)
                              },
                              expression: "form.quantityActual"
                            }
                          }),
                          _c("span", [_vm._v("PCS")])
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.weightContract.viewable
                ? _c(
                    "el-form-item",
                    {
                      attrs: { slot: "weightContract" },
                      slot: "weightContract"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.weightContract.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.weightContract.label
                        },
                        slot: "label"
                      }),
                      _c(
                        "div",
                        { staticStyle: { display: "flex" } },
                        [
                          _c("auto-number-input", {
                            attrs: {
                              disabled: !_vm.elementDict.weightContract
                                .writable,
                              no: "weightContract",
                              precision: 3,
                              min: 0
                            },
                            on: { change: _vm.weightContractChange },
                            model: {
                              value: _vm.form.weightContract,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "weightContract", $$v)
                              },
                              expression: "form.weightContract"
                            }
                          }),
                          _c("span", { staticStyle: { padding: "0 2px" } }, [
                            _vm._v("/")
                          ]),
                          _c("auto-number-input", {
                            ref: "weightActual",
                            attrs: {
                              no: "weightActual",
                              precision: 3,
                              disabled:
                                _vm.pm.billChargeFlag ||
                                !_vm.elementDict.weightContract.writable,
                              min: 0
                            },
                            on: { change: _vm.weightActualChange },
                            model: {
                              value: _vm.form.weightActual,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "weightActual", $$v)
                              },
                              expression: "form.weightActual"
                            }
                          }),
                          _c("span", [_vm._v("KGS")])
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.cubageContract.viewable
                ? _c(
                    "el-form-item",
                    {
                      attrs: { slot: "cubageContract" },
                      slot: "cubageContract"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.cubageContract.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.cubageContract.label
                        },
                        slot: "label"
                      }),
                      _c(
                        "div",
                        { staticStyle: { display: "flex" } },
                        [
                          _c("auto-number-input", {
                            attrs: {
                              disabled: !_vm.elementDict.cubageContract
                                .writable,
                              no: "cubageContract",
                              precision: 3,
                              min: 0
                            },
                            on: { change: _vm.cubageContractChange },
                            model: {
                              value: _vm.form.cubageContract,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "cubageContract", $$v)
                              },
                              expression: "form.cubageContract"
                            }
                          }),
                          _c("span", { staticStyle: { padding: "0 2px" } }, [
                            _vm._v("/")
                          ]),
                          _c("auto-number-input", {
                            ref: "cubageActual",
                            attrs: {
                              no: "cubageActual",
                              precision: 3,
                              disabled:
                                !_vm.cubageActualEnabled ||
                                !_vm.elementDict.cubageContract.writable,
                              min: 0
                            },
                            on: { change: _vm.cubageActualChange },
                            model: {
                              value: _vm.form.cubageActual,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "cubageActual", $$v)
                              },
                              expression: "form.cubageActual"
                            }
                          }),
                          _c("span", [_vm._v("CBM")])
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.packing.viewable
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "packing" }, slot: "packing" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.packing.isRequire ? "blue" : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.packing.label
                        },
                        slot: "label"
                      }),
                      _c("cargo-packing-select", {
                        attrs: {
                          no: "packing",
                          "default-value": _vm.form.packing,
                          disabled: !_vm.elementDict.packing.writable
                        },
                        on: {
                          change: function(p) {
                            _vm.form.packing = p.value
                            _vm.pm.txtPackingChangeHandler()
                          }
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.insideQuantity.viewable
                ? _c(
                    "el-form-item",
                    {
                      attrs: { slot: "insideQuantity" },
                      slot: "insideQuantity"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.insideQuantity.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.insideQuantity.label
                        },
                        slot: "label"
                      }),
                      _c("auto-number-input", {
                        attrs: {
                          no: "insideQuantity",
                          precision: 0,
                          min: 0,
                          disabled: !_vm.elementDict.insideQuantity.writable
                        },
                        on: {
                          valCallBack: function(val) {
                            _vm.form.insideQuantity = val
                          }
                        },
                        model: {
                          value: _vm.form.insideQuantity,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "insideQuantity", $$v)
                          },
                          expression: "form.insideQuantity"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.insidePacking.viewable
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "insidePacking" }, slot: "insidePacking" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.insidePacking.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.insidePacking.label
                        },
                        slot: "label"
                      }),
                      _c("cargo-packing-select", {
                        attrs: {
                          no: "insidePacking",
                          "default-value": _vm.form.insidePacking,
                          disabled: !_vm.elementDict.insidePacking.writable
                        },
                        on: {
                          change: function(p) {
                            _vm.form.insidePacking = p.value
                          }
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.chargeWeight.viewable
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "chargeWeight" }, slot: "chargeWeight" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.chargeWeight.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.chargeWeight.label
                        },
                        slot: "label"
                      }),
                      _c(
                        "div",
                        { staticStyle: { display: "flex" } },
                        [
                          _c("auto-number-input", {
                            staticStyle: { flex: "1" },
                            attrs: {
                              no: "chargeWeight",
                              precision: 3,
                              disabled:
                                !_vm.chargeWeightEnabled ||
                                !_vm.elementDict.chargeWeight.writable,
                              min: 0
                            },
                            on: {
                              change: function($event) {
                                return _vm.pm.chargeWeightChange()
                              }
                            },
                            model: {
                              value: _vm.form.chargeWeight,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "chargeWeight", $$v)
                              },
                              expression: "form.chargeWeight"
                            }
                          }),
                          _c("span", [_vm._v("M/T")])
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.cargoEnglishName.viewable
                ? _c(
                    "template",
                    { slot: "cargoEnglishName" },
                    [
                      _c(
                        "el-form-item",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value:
                                _vm.isEdit &&
                                _vm.elementDict.cargoEnglishName.writable,
                              expression:
                                "isEdit && elementDict.cargoEnglishName.writable"
                            }
                          ]
                        },
                        [
                          _c(
                            "div",
                            { attrs: { slot: "label" }, slot: "label" },
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: {
                                    no: "Copy2",
                                    type: "primary",
                                    disabled: !_vm.elementDict.cargoEnglishName
                                      .writable
                                  },
                                  on: {
                                    click: function($event) {
                                      _vm.transcribeDialog.visible = true
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("SeaExport.Copy2")) + " "
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ]
                      ),
                      _c(
                        "el-form-item",
                        [
                          _c("line-label", {
                            class: _vm.elementDict.cargoEnglishName.isRequire
                              ? "blue"
                              : "",
                            attrs: {
                              slot: "label",
                              label: _vm.elementDict.cargoEnglishName.label
                            },
                            slot: "label"
                          }),
                          _c(
                            "special-character-tip",
                            {
                              attrs: {
                                texts: _vm.specialCharCheck.cargoEnglishName
                              }
                            },
                            [
                              _c("cargo-rich-textarea", {
                                ref: "cargoTextarea1",
                                staticStyle: { height: "110px" },
                                attrs: {
                                  "show-count": true,
                                  no: "cargoEnglishName",
                                  "text-chars": 0,
                                  "warning-count": -1,
                                  disabled:
                                    !_vm.isEdit ||
                                    !_vm.elementDict.cargoEnglishName
                                      .writable ||
                                    !_vm.elementDict.cargoEnglishName.writable,
                                  "wrap-symbol": "r",
                                  "auto-half-word": "",
                                  "auto-uppercase": _vm.isUppercaseByConfig
                                },
                                nativeOn: {
                                  dblclick: function($event) {
                                    _vm.showAdvanceTextDialog(
                                      _vm.$t(
                                        "SeaExport.EnglishDescriptionOfGoods"
                                      ),
                                      _vm.form.cargoEnglishName,
                                      function(val) {},
                                      true,
                                      {
                                        autoHalfWord: true,
                                        autoUppercase: _vm.isUppercaseByConfig
                                      }
                                    )
                                  }
                                },
                                model: {
                                  value: _vm.form.cargoEnglishName,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "cargoEnglishName", $$v)
                                  },
                                  expression: "form.cargoEnglishName"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "el-form-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.elementDict.mark.viewable,
                      expression: "elementDict.mark.viewable"
                    }
                  ],
                  attrs: { slot: "mark" },
                  slot: "mark"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.mark.isRequire ? "blue" : "",
                    attrs: { slot: "label", label: _vm.elementDict.mark.label },
                    slot: "label"
                  }),
                  _c(
                    "special-character-tip",
                    { attrs: { texts: _vm.specialCharCheck.mark } },
                    [
                      _c("cargo-rich-textarea", {
                        ref: "cargoTextarea2",
                        staticStyle: { height: "110px" },
                        attrs: {
                          "show-count": true,
                          no: "mark",
                          "text-chars": 0,
                          "warning-count": -1,
                          "wrap-symbol": "r",
                          "auto-half-word": "",
                          "auto-uppercase": _vm.isUppercaseByConfig,
                          disabled:
                            !_vm.isEdit || !_vm.elementDict.mark.writable
                        },
                        nativeOn: {
                          dblclick: function($event) {
                            _vm.showAdvanceTextDialog(
                              _vm.$t("SeaExport.Marks"),
                              _vm.form.mark,
                              function(val) {},
                              true,
                              {
                                autoHalfWord: true,
                                autoUppercase: _vm.isUppercaseByConfig
                              }
                            )
                          }
                        },
                        model: {
                          value: _vm.form.mark,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "mark", $$v)
                          },
                          expression: "form.mark"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm.elementDict.hsCode.viewable
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "hsCode" }, slot: "hsCode" },
                    [
                      _c(
                        "div",
                        { attrs: { slot: "label" }, slot: "label" },
                        [
                          _c("line-label", {
                            class: _vm.elementDict.hsCode.isRequire
                              ? "blue"
                              : "",
                            attrs: {
                              slot: "label",
                              label: _vm.elementDict.hsCode.label
                            },
                            slot: "label"
                          }),
                          _c("br"),
                          _c(
                            "el-button",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.isEdit,
                                  expression: "isEdit"
                                }
                              ],
                              attrs: {
                                no: "Search",
                                type: "primary",
                                disabled: !_vm.elementDict.hsCode.writable
                              },
                              on: {
                                click: function($event) {
                                  _vm.showHsCodeSearchDialog(
                                    _vm.$t("Message.SelectHsCode"),
                                    function(p) {
                                      return (_vm.form.hsCode = p.code)
                                    }
                                  )
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("SeaExport.Search")) + " ")]
                          )
                        ],
                        1
                      ),
                      _c("el-input", {
                        attrs: {
                          no: "hsCode",
                          type: "textarea",
                          rows: 5,
                          disabled: !_vm.elementDict.hsCode.writable
                        },
                        nativeOn: {
                          dblclick: function($event) {
                            _vm.showAdvanceTextDialog(
                              _vm.$t("SeaExport.HsCode"),
                              _vm.form.hsCode,
                              function(val) {
                                _vm.form.hsCode = val
                              }
                            )
                          }
                        },
                        model: {
                          value: _vm.form.hsCode,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "hsCode", $$v)
                          },
                          expression: "form.hsCode"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.cargoChineseName.viewable
                ? _c(
                    "el-form-item",
                    {
                      attrs: { slot: "cargoChineseName" },
                      slot: "cargoChineseName"
                    },
                    [
                      _c(
                        "div",
                        { attrs: { slot: "label" }, slot: "label" },
                        [
                          _c("line-label", {
                            class: _vm.elementDict.cargoChineseName.isRequire
                              ? "blue"
                              : "",
                            attrs: {
                              slot: "label",
                              label: _vm.elementDict.cargoChineseName.label
                            },
                            slot: "label"
                          }),
                          _c("br"),
                          _c(
                            "el-button",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.isEdit,
                                  expression: "isEdit"
                                }
                              ],
                              attrs: {
                                no: "ChineseDescriptionOfGoods",
                                type: "primary",
                                disabled: !_vm.elementDict.cargoChineseName
                                  .writable
                              },
                              on: {
                                click: function($event) {
                                  _vm.showHsCodeSearchDialog(
                                    _vm.$t("Message.SelectCargoChineseName"),
                                    function(p) {
                                      return (_vm.form.cargoChineseName =
                                        p.commodityName)
                                    }
                                  )
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("SeaExport.Search")) + " ")]
                          )
                        ],
                        1
                      ),
                      _c("cargo-rich-textarea", {
                        staticStyle: { height: "110px" },
                        attrs: {
                          "show-count": true,
                          no: "cargoChineseName",
                          disabled:
                            !_vm.isEdit ||
                            !_vm.elementDict.cargoChineseName.writable,
                          "auto-uppercase": false,
                          "auto-half-word": false,
                          "wrap-symbol": "r"
                        },
                        nativeOn: {
                          dblclick: function($event) {
                            _vm.showAdvanceTextDialog(
                              _vm.$t("SeaExport.ChineseDescriptionOfGoods"),
                              _vm.form.cargoChineseName,
                              function(val) {
                                _vm.form.cargoChineseName = val
                              }
                            )
                          }
                        },
                        model: {
                          value: _vm.form.cargoChineseName,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "cargoChineseName", $$v)
                          },
                          expression: "form.cargoChineseName"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.waybillInvoice.viewable
                ? _c(
                    "el-form-item",
                    {
                      attrs: { slot: "waybillInvoice" },
                      slot: "waybillInvoice"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.waybillInvoice.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.waybillInvoice.label
                        },
                        slot: "label"
                      }),
                      _c("el-input", {
                        attrs: {
                          disabled: !_vm.elementDict.waybillInvoice.writable,
                          no: "waybillInvoice",
                          type: "textarea",
                          rows: 5
                        },
                        model: {
                          value: _vm.form.waybillInvoice,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "waybillInvoice", $$v)
                          },
                          expression: "form.waybillInvoice"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.salesOffice.viewable
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "salesOffice" }, slot: "salesOffice" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.salesOffice.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.salesOffice.label
                        },
                        slot: "label"
                      }),
                      _c("el-input", {
                        attrs: { value: _vm.txtSalesOffice, disabled: true }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.sales.viewable
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "sales" }, slot: "sales" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.sales.isRequire ? "blue" : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.sales.label
                        },
                        slot: "label"
                      }),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "justify-content": "space-between"
                          }
                        },
                        [
                          _c("cargo-user-select", {
                            ref: "sales",
                            staticStyle: { flex: "1" },
                            attrs: {
                              no: "sales",
                              disabled:
                                !(
                                  _vm.trustFromEditSales || !_vm.form.relatedJob
                                ) || !_vm.elementDict.sales.writable,
                              "method-params": {
                                officeId: _vm.salesOfficeCheck
                                  ? _vm.$store.getters.currentOfficeId
                                  : "",
                                category: "role",
                                shape: "sales"
                              },
                              "default-value": _vm.form.sales || "",
                              "static-options": _vm.salesList,
                              placeholder: _vm.salesPrompt,
                              "merge-load": true
                            },
                            on: {
                              change: function(p) {
                                _vm.form.salesRecord = p.value
                                _vm.pm.salesChangeHandler(p)
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "el-checkbox",
                            {
                              staticStyle: { "margin-left": "5px" },
                              attrs: { no: "provisioned", disabled: true },
                              model: {
                                value: _vm.form.provisioned,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "provisioned", $$v)
                                },
                                expression: "form.provisioned"
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("SeaExport.Accrued")) + " ")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.cargoSalesId.viewable
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "cargoSalesId" }, slot: "cargoSalesId" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.cargoSalesId.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.cargoSalesId.label
                        },
                        slot: "label"
                      }),
                      _c("cargo-user-select", {
                        attrs: {
                          no: "cargoSalesId",
                          "method-params": {
                            category: "role",
                            shape: "salesOfGoods"
                          },
                          "default-value": _vm.form.cargoSalesId || "",
                          "merge-load": true,
                          disabled: !_vm.elementDict.cargoSalesId.writable,
                          "static-options": _vm.cargoSalesList
                        },
                        on: {
                          change: function(p) {
                            _vm.form.cargoSalesId = p.value
                          }
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.salesDepartment.viewable
                ? _c(
                    "el-form-item",
                    {
                      attrs: { slot: "salesDepartment" },
                      slot: "salesDepartment"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.salesDepartment.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.salesDepartment.label
                        },
                        slot: "label"
                      }),
                      _c("cargo-department-new-select", {
                        attrs: {
                          no: "salesDepartment",
                          disabled:
                            _vm.readonly ||
                            !_vm.elementDict.salesDepartment.writable ||
                            !_vm.form.sales ||
                            !_vm.elementDict.salesDepartment.writable,
                          "sales-id": Number(_vm.form.sales),
                          "office-id": _vm.form.salesOffice,
                          enables: true,
                          "department-id": Number(_vm.form.salesDepartment)
                        },
                        on: {
                          change: function(p) {
                            _vm.form.salesDepartment = p.value
                          }
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.opOffice.viewable
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "opOffice" }, slot: "opOffice" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.opOffice.isRequire ? "blue" : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.opOffice.label
                        },
                        slot: "label"
                      }),
                      _c("cargo-office-select", {
                        attrs: {
                          no: "opOffice",
                          disabled:
                            (!_vm.isRegionalCommission &&
                              _vm.pm.isEntrustOrder(true)) ||
                            _vm.opOfficeDisabled ||
                            !_vm.elementDict.opOffice.writable,
                          "is-regional-commission": _vm.isRegionalCommission,
                          "office-id": Number(_vm.form.opOffice)
                        },
                        on: {
                          change: function(p) {
                            _vm.form.opOffice = p.value
                            _vm.form.opDepartment = 0
                            _vm.opOfficeChargeHandler()
                            _vm.contractRuleFieldChange(
                              _vm.form.customerId,
                              _vm.form.designationAgent
                            )
                          }
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.opDepartment.viewable
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "opDepartment" }, slot: "opDepartment" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.opDepartment.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.opDepartment.label
                        },
                        slot: "label"
                      }),
                      _c("cargo-department-select", {
                        attrs: {
                          no: "opDepartment",
                          "office-id": Number(_vm.form.opOffice),
                          enables: true,
                          disabled: !_vm.elementDict.opDepartment.writable,
                          "department-id": Number(_vm.form.opDepartment)
                        },
                        on: {
                          change: function(p) {
                            _vm.form.opDepartment = p.value
                          }
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.op.viewable
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "op" }, slot: "op" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.op.isRequire ? "blue" : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.op.label
                        },
                        slot: "label"
                      }),
                      _c("cargo-user-select", {
                        ref: "op",
                        attrs: {
                          no: "op",
                          "method-params": {
                            officeId: _vm.form.opOffice,
                            category: "role",
                            shape: "op"
                          },
                          "default-value": _vm.form.op || "",
                          "merge-load": true,
                          disabled: !_vm.elementDict.op.writable
                        },
                        on: {
                          change: function(p) {
                            _vm.form.op = p.value
                            _vm.pm.txtOPChangeHandler(p)
                          }
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.csrOffice.viewable
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "csrOffice" }, slot: "csrOffice" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.csrOffice.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.csrOffice.label
                        },
                        slot: "label"
                      }),
                      _c("cargo-office-select", {
                        attrs: {
                          no: "csrOffice",
                          disabled: true,
                          "office-id": Number(_vm.form.csrOffice)
                        },
                        on: {
                          change: function(p) {
                            _vm.form.csrOffice = p.value
                            _vm.form.csrDepartment = 0
                          }
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.csrDepartment.viewable
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "csrDepartment" }, slot: "csrDepartment" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.csrDepartment.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.csrDepartment.label
                        },
                        slot: "label"
                      }),
                      _c("cargo-department-select", {
                        attrs: {
                          no: "csrDepartment",
                          "office-id": Number(_vm.form.csrOffice),
                          enables: true,
                          disabled: !_vm.elementDict.csrDepartment.writable,
                          "department-id": Number(_vm.form.csrDepartment)
                        },
                        on: {
                          change: function(p) {
                            _vm.form.csrDepartment = p.value
                          }
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.csr.viewable
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "csr" }, slot: "csr" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.csr.isRequire ? "blue" : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.csr.label
                        },
                        slot: "label"
                      }),
                      _c("cargo-user-select", {
                        ref: "csr",
                        attrs: {
                          no: "csr",
                          "method-params": {
                            officeId:
                              _vm.pm.isEntrustOrder ||
                              _vm.form.salesOffice === 1
                                ? _vm.form.opOffice
                                : _vm.form.salesOffice,
                            category: "role",
                            shape: "csr"
                          },
                          "default-value": _vm.form.csr || "",
                          "merge-load": true,
                          disabled: !_vm.elementDict.csr.writable
                        },
                        on: {
                          change: function(p) {
                            _vm.pm.csrChangeHandler(p)
                          }
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.siteOP.viewable
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "siteOP" }, slot: "siteOP" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.siteOP.isRequire ? "blue" : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.siteOP.label
                        },
                        slot: "label"
                      }),
                      _c("cargo-user-select", {
                        ref: "siteOp",
                        attrs: {
                          no: "siteOp",
                          "method-params": {
                            officeId: _vm.form.opOffice,
                            category: "role",
                            shape: "siteOp"
                          },
                          "default-value": _vm.form.siteOP || "",
                          disabled: !_vm.elementDict.siteOP.writable
                        },
                        on: {
                          change: function(p) {
                            _vm.pm.siteOpChangeHandler(p)
                          }
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "el-form-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.elementDict.overseaOp.viewable,
                      expression: "elementDict.overseaOp.viewable"
                    }
                  ],
                  attrs: { slot: "overseaOp" },
                  slot: "overseaOp"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.overseaOp.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.overseaOp.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-user-select", {
                    ref: "overseaOp",
                    attrs: {
                      no: "overseaOp",
                      "default-value": _vm.form.overseaOp || "",
                      "method-params": { category: "role", shape: "overseaOp" },
                      "static-options": _vm.isHC
                        ? null
                        : _vm.overseaAgentUsersList,
                      "merge-load": true,
                      disabled: !_vm.elementDict.overseaOp.writable
                    },
                    on: {
                      change: function(p) {
                        _vm.form.overseaOp = p.value
                        _vm.pm.overseaOpChangeHandler(p)
                      }
                    }
                  })
                ],
                1
              ),
              _vm.elementDict.truckCsr.viewable
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "truckCsr" }, slot: "truckCsr" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.truckCsr.isRequire ? "blue" : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.truckCsr.label
                        },
                        slot: "label"
                      }),
                      _c("cargo-user-select", {
                        ref: "truckCsr",
                        attrs: {
                          no: "truckCsr",
                          "method-params": {
                            officeId: _vm.form.opOffice,
                            category: "role",
                            shape: "truckCsr"
                          },
                          "default-value": _vm.form.truckCsr || "",
                          "merge-load": true,
                          disabled: !_vm.elementDict.truckCsr.writable
                        },
                        on: {
                          change: function(p) {
                            _vm.pm.truckCsrChangeHandler(p)
                          }
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.dcOffice.viewable
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "dcOffice" }, slot: "dcOffice" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.dcOffice.isRequire ? "blue" : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.dcOffice.label
                        },
                        slot: "label"
                      }),
                      _c("cargo-office-select", {
                        attrs: {
                          no: "dcOffice",
                          disabled: true,
                          "office-id": Number(_vm.form.dcOffice)
                        },
                        on: {
                          change: function(p) {
                            _vm.form.dcOffice = p.value
                            _vm.form.dcDepartment = 0
                          }
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.dcDepartment.viewable
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "dcDepartment" }, slot: "dcDepartment" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.dcDepartment.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.dcDepartment.label
                        },
                        slot: "label"
                      }),
                      _c("cargo-department-select", {
                        attrs: {
                          no: "dcDepartment",
                          "office-id": Number(_vm.form.dcOffice),
                          enables: true,
                          disabled: !_vm.elementDict.dcDepartment.writable,
                          "department-id": Number(_vm.form.dcDepartment)
                        },
                        on: {
                          change: function(p) {
                            _vm.form.dcDepartment = p.value
                          }
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.dc.viewable
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "dc" }, slot: "dc" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.dc.isRequire ? "blue" : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.dc.label
                        },
                        slot: "label"
                      }),
                      _c("cargo-user-select", {
                        ref: "dc",
                        attrs: {
                          no: "dc",
                          "method-params": {
                            officeId: _vm.form.opOffice,
                            category: "role",
                            shape: "doc"
                          },
                          "default-value": _vm.form.dc || "",
                          "merge-load": true,
                          disabled: !_vm.elementDict.dc.writable
                        },
                        on: {
                          change: function(p) {
                            _vm.pm.dcChangeHandler(p)
                          }
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.planner.viewable
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "planner" }, slot: "planner" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.planner.isRequire ? "blue" : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.planner.label
                        },
                        slot: "label"
                      }),
                      _c("cargo-user-select", {
                        attrs: {
                          no: "planner",
                          "method-params": {
                            officeId: _vm.form.opOffice,
                            category: "role",
                            shape: "seaLine"
                          },
                          "default-value": _vm.form.planner || "",
                          "merge-load": true,
                          disabled: !_vm.elementDict.planner.writable
                        },
                        on: {
                          change: function(p) {
                            _vm.form.planner = p.value
                            _vm.pm.txtPlannerChangeHandler(p)
                          }
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.userDefinedRoleId1.viewable
                ? _c(
                    "el-form-item",
                    {
                      attrs: { slot: "userDefinedRoleId1" },
                      slot: "userDefinedRoleId1"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.userDefinedRoleId1.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.userDefinedRoleId1.label
                        },
                        slot: "label"
                      }),
                      _c("cargo-user-select", {
                        ref: "userDefinedRoleId1",
                        attrs: {
                          no: "userDefinedRoleId1",
                          "method-params": {
                            officeId: _vm.$store.getters.currentOfficeId,
                            category: "role",
                            shape: "userDefinedRole1"
                          },
                          "default-value": _vm.form.userDefinedRoleId1 || "",
                          "merge-load": true,
                          disabled: !_vm.elementDict.userDefinedRoleId1.writable
                        },
                        on: {
                          change: function(p) {
                            _vm.pm.userDefinedRoleId1Handler(p)
                          }
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.userDefinedRoleId2.viewable
                ? _c(
                    "el-form-item",
                    {
                      attrs: { slot: "userDefinedRoleId2" },
                      slot: "userDefinedRoleId2"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.userDefinedRoleId2.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.userDefinedRoleId2.label
                        },
                        slot: "label"
                      }),
                      _c("cargo-user-select", {
                        ref: "userDefinedRoleId2",
                        attrs: {
                          no: "userDefinedRoleId2",
                          "method-params": {
                            officeId: _vm.$store.getters.currentOfficeId,
                            category: "role",
                            shape: "userDefinedRole2"
                          },
                          "default-value": _vm.form.userDefinedRoleId2 || "",
                          "merge-load": true,
                          disabled: !_vm.elementDict.userDefinedRoleId2.writable
                        },
                        on: {
                          change: function(p) {
                            _vm.pm.userDefinedRoleId2Handler(p)
                          }
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.userDefinedRoleId3.viewable
                ? _c(
                    "el-form-item",
                    {
                      attrs: { slot: "userDefinedRoleId3" },
                      slot: "userDefinedRoleId3"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.userDefinedRoleId3.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.userDefinedRoleId3.label
                        },
                        slot: "label"
                      }),
                      _c("cargo-user-select", {
                        ref: "userDefinedRoleId3",
                        attrs: {
                          no: "userDefinedRoleId3",
                          "method-params": {
                            officeId: _vm.$store.getters.currentOfficeId,
                            category: "role",
                            shape: "userDefinedRole3"
                          },
                          "default-value": _vm.form.userDefinedRoleId3 || "",
                          "merge-load": true,
                          disabled: !_vm.elementDict.userDefinedRoleId3.writable
                        },
                        on: {
                          change: function(p) {
                            _vm.pm.userDefinedRoleIdHandler(
                              p,
                              "userDefinedRoleId3",
                              "userDefinedRoleDept3",
                              "userDefinedRoleOffice3",
                              "userDefinedRole3"
                            )
                          }
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.userDefinedRoleId4.viewable
                ? _c(
                    "el-form-item",
                    {
                      attrs: { slot: "userDefinedRoleId4" },
                      slot: "userDefinedRoleId4"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.userDefinedRoleId4.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.userDefinedRoleId4.label
                        },
                        slot: "label"
                      }),
                      _c("cargo-user-select", {
                        ref: "userDefinedRoleId4",
                        attrs: {
                          no: "userDefinedRoleId4",
                          "method-params": {
                            officeId: _vm.$store.getters.currentOfficeId,
                            category: "role",
                            shape: "userDefinedRole4"
                          },
                          "default-value": _vm.form.userDefinedRoleId4 || "",
                          "merge-load": true,
                          disabled: !_vm.elementDict.userDefinedRoleId4.writable
                        },
                        on: {
                          change: function(p) {
                            _vm.pm.userDefinedRoleIdHandler(
                              p,
                              "userDefinedRoleId4",
                              "userDefinedRoleDept4",
                              "userDefinedRoleOffice4",
                              "userDefinedRole4"
                            )
                          }
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.userDefinedRoleId5.viewable
                ? _c(
                    "el-form-item",
                    {
                      attrs: { slot: "userDefinedRoleId5" },
                      slot: "userDefinedRoleId5"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.userDefinedRoleId5.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.userDefinedRoleId5.label
                        },
                        slot: "label"
                      }),
                      _c("cargo-user-select", {
                        ref: "userDefinedRoleId5",
                        attrs: {
                          no: "userDefinedRoleId5",
                          "method-params": {
                            officeId: _vm.$store.getters.currentOfficeId,
                            category: "role",
                            shape: "userDefinedRole5"
                          },
                          "default-value": _vm.form.userDefinedRoleId5 || "",
                          "merge-load": true,
                          disabled: !_vm.elementDict.userDefinedRoleId5.writable
                        },
                        on: {
                          change: function(p) {
                            _vm.pm.userDefinedRoleIdHandler(
                              p,
                              "userDefinedRoleId5",
                              "userDefinedRoleDept5",
                              "userDefinedRoleOffice5",
                              "userDefinedRole5"
                            )
                          }
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.userDefinedRoleId6.viewable
                ? _c(
                    "el-form-item",
                    {
                      attrs: { slot: "userDefinedRoleId6" },
                      slot: "userDefinedRoleId6"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.userDefinedRoleId6.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.userDefinedRoleId6.label
                        },
                        slot: "label"
                      }),
                      _c("cargo-user-select", {
                        ref: "userDefinedRoleId6",
                        attrs: {
                          no: "userDefinedRoleId6",
                          "method-params": {
                            officeId: _vm.$store.getters.currentOfficeId,
                            category: "role",
                            shape: "userDefinedRole6"
                          },
                          "default-value": _vm.form.userDefinedRoleId6 || "",
                          "merge-load": true,
                          disabled: !_vm.elementDict.userDefinedRoleId6.writable
                        },
                        on: {
                          change: function(p) {
                            _vm.pm.userDefinedRoleIdHandler(
                              p,
                              "userDefinedRoleId6",
                              "userDefinedRoleDept6",
                              "userDefinedRoleOffice6",
                              "userDefinedRole6"
                            )
                          }
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.userDefinedRoleId7.viewable
                ? _c(
                    "el-form-item",
                    {
                      attrs: { slot: "userDefinedRoleId7" },
                      slot: "userDefinedRoleId7"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.userDefinedRoleId7.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.userDefinedRoleId7.label
                        },
                        slot: "label"
                      }),
                      _c("cargo-user-select", {
                        ref: "userDefinedRoleId7",
                        attrs: {
                          no: "userDefinedRoleId7",
                          "method-params": {
                            officeId: _vm.$store.getters.currentOfficeId,
                            category: "role",
                            shape: "userDefinedRole7"
                          },
                          "default-value": _vm.form.userDefinedRoleId7 || "",
                          "merge-load": true,
                          disabled: !_vm.elementDict.userDefinedRoleId7.writable
                        },
                        on: {
                          change: function(p) {
                            _vm.pm.userDefinedRoleIdHandler(
                              p,
                              "userDefinedRoleId7",
                              "userDefinedRoleDept7",
                              "userDefinedRoleOffice7",
                              "userDefinedRole7"
                            )
                          }
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.userDefinedRoleId8 &&
              _vm.elementDict.userDefinedRoleId8.viewable
                ? _c(
                    "el-form-item",
                    {
                      attrs: { slot: "userDefinedRoleId8" },
                      slot: "userDefinedRoleId8"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.userDefinedRoleId8.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.userDefinedRoleId8.label
                        },
                        slot: "label"
                      }),
                      _c("cargo-user-select", {
                        ref: "userDefinedRoleId8",
                        attrs: {
                          no: "userDefinedRoleId8",
                          "method-params": {
                            officeId: _vm.$store.getters.currentOfficeId,
                            category: "role",
                            shape: "userDefinedRole8"
                          },
                          "default-multiple-value": _vm.toNumArray(
                            _vm.form.userDefinedRoleId8
                          ),
                          multiple: true,
                          "merge-load": true,
                          placeholder: _vm.readonly ? " " : ""
                        },
                        on: {
                          change: function(p) {
                            _vm.form.userDefinedRoleId8 = _vm.toTxt(p.value)
                          }
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _c("special-requests-grid", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.elementDict.satisfiedRequests.viewable,
                    expression: "elementDict.satisfiedRequests.viewable"
                  }
                ],
                ref: "selectedSpecialRequest",
                staticStyle: { "margin-bottom": "5px" },
                attrs: {
                  slot: "satisfiedRequests",
                  no: "satisfiedRequests",
                  "is-edit":
                    _vm.isEdit && _vm.elementDict.satisfiedRequests.writable,
                  "customer-id": Number(_vm.form.customerId),
                  lob: _vm.form.lob,
                  job: _vm.form
                },
                slot: "satisfiedRequests",
                model: {
                  value: _vm.form.satisfiedRequests,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "satisfiedRequests", $$v)
                  },
                  expression: "form.satisfiedRequests"
                }
              }),
              _vm.elementDict.operationContent.viewable
                ? _c(
                    "el-form-item",
                    {
                      attrs: { slot: "operationContent" },
                      slot: "operationContent"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.operationContent.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.operationContent.label
                        },
                        slot: "label"
                      }),
                      _c(
                        "el-tooltip",
                        {
                          attrs: {
                            content: _vm.form.operationContent,
                            placement: "left"
                          }
                        },
                        [
                          _c("div", {
                            attrs: { slot: "content" },
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.form.operationContent
                                  ? _vm.form.operationContent.replace(
                                      /[\n]/g,
                                      "</br>"
                                    )
                                  : _vm.$t("SeaExport.NoData")
                              )
                            },
                            slot: "content"
                          }),
                          _c("el-input", {
                            attrs: {
                              no: "operationContent",
                              value: _vm.form.operationContent,
                              placeholder: _vm.readonly
                                ? ""
                                : _vm.$t(
                                    "SeaExport.DoubleClickToAddOperationRequirements"
                                  ),
                              type: "textarea",
                              rows: 4,
                              disabled: !_vm.elementDict.operationContent
                                .writable
                            },
                            nativeOn: {
                              dblclick: function($event) {
                                _vm.selectOperationReqDialog.value =
                                  _vm.form.operationContent
                                _vm.selectOperationReqDialog.visible =
                                  _vm.isEdit
                              }
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.operationTips.viewable
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "operationTips" }, slot: "operationTips" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.operationTips.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.operationTips.label
                        },
                        slot: "label"
                      }),
                      _c("el-input", {
                        attrs: {
                          no: "operationTips",
                          type: "textarea",
                          rows: 4,
                          disabled: !_vm.elementDict.operationTips.writable
                        },
                        model: {
                          value: _vm.form.operationTips,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "operationTips", $$v)
                          },
                          expression: "form.operationTips"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "el-form",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.elementDict.shipper.viewable,
                      expression: "elementDict.shipper.viewable"
                    }
                  ],
                  staticStyle: { "margin-right": "10px" },
                  attrs: {
                    slot: "shipper",
                    disabled: _vm.readonly || !_vm.elementDict.shipper.writable,
                    "label-width": "50px",
                    "label-position": "right"
                  },
                  slot: "shipper"
                },
                [
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "template",
                        { slot: "label" },
                        [
                          _c("line-label", {
                            class: _vm.elementDict.shipper.isRequire
                              ? "blue"
                              : "",
                            attrs: { label: _vm.elementDict.shipper.label }
                          }),
                          _c("char-count", {
                            staticStyle: {
                              position: "static",
                              display: "block",
                              "font-size": "10px",
                              color: "#909399"
                            },
                            attrs: { form: _vm.form, prefix: "shipper" }
                          })
                        ],
                        1
                      ),
                      _c("cargo-company-select", {
                        staticStyle: {
                          display: "inline-block",
                          width: "175px"
                        },
                        attrs: {
                          no: "shipperId",
                          "method-params": {
                            shipper: true,
                            active: true,
                            companyLob: "integratedJob"
                          },
                          "default-value": _vm.form.shipperId || ""
                        },
                        on: {
                          change: function(data) {
                            _vm.pm.shipperChange(data)
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          attrs: { no: "shipperBillAddress", type: "primary" },
                          on: {
                            click: function($event) {
                              _vm.billAddressDialog.visible = true
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("SeaExport.CodeSearching")))]
                      )
                    ],
                    2
                  ),
                  _vm._l(7, function(i) {
                    return _c(
                      "el-form-item",
                      { key: i, attrs: { "label-width": "0" } },
                      [
                        _c("cargo-input", {
                          ref: "shipperLine" + i,
                          refInFor: true,
                          attrs: {
                            no: "shipperLine" + i,
                            "auto-uppercase":
                              _vm.notUppercaseShipperConsigneNotify
                          },
                          on: {
                            change: function() {
                              return _vm.wrapAddr(
                                _vm.form,
                                "shipperLine" + i,
                                i + 1 > 6 ? null : "shipperLine" + (i + 1),
                                ""
                              )
                            }
                          },
                          nativeOn: {
                            dblclick: function($event) {
                              _vm.showAdvanceTextDialog(
                                _vm.$t("SeaExport.Shipper"),
                                _vm.mergeShipperLine(),
                                _vm.splitShipperLine,
                                _vm.notUppercaseShipperConsigneNotify,
                                null
                              )
                            }
                          },
                          model: {
                            value: _vm.form["shipperLine" + i],
                            callback: function($$v) {
                              _vm.$set(_vm.form, "shipperLine" + i, $$v)
                            },
                            expression: "form['shipperLine'+i]"
                          }
                        })
                      ],
                      1
                    )
                  })
                ],
                2
              ),
              _c(
                "el-form",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.elementDict.consignee.viewable,
                      expression: "elementDict.consignee.viewable"
                    }
                  ],
                  staticStyle: { "margin-right": "10px" },
                  attrs: {
                    slot: "consignee",
                    disabled:
                      _vm.readonly || !_vm.elementDict.consignee.writable,
                    "label-width": "50px",
                    "label-position": "right"
                  },
                  slot: "consignee"
                },
                [
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "template",
                        { slot: "label" },
                        [
                          _c("line-label", {
                            class: _vm.elementDict.consignee.isRequire
                              ? "blue"
                              : "",
                            attrs: { label: _vm.elementDict.consignee.label }
                          }),
                          _c("char-count", {
                            staticStyle: {
                              position: "static",
                              display: "block",
                              "font-size": "10px",
                              color: "#909399"
                            },
                            attrs: { form: _vm.form, prefix: "consignee" }
                          })
                        ],
                        1
                      ),
                      _c("cargo-company-select", {
                        staticStyle: {
                          display: "inline-block",
                          width: "175px"
                        },
                        attrs: {
                          no: "consigneeId",
                          "method-params": {
                            consignee: true,
                            active: true,
                            companyLob: "integratedJob"
                          },
                          "default-value": _vm.form.consigneeId || ""
                        },
                        on: {
                          change: function(data) {
                            _vm.pm.consigneeChange(data)
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          attrs: {
                            no: "consigneeBillAddress",
                            type: "primary"
                          },
                          on: {
                            click: function($event) {
                              _vm.billAddressDialog.visible = true
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("SeaExport.CodeSearching")))]
                      )
                    ],
                    2
                  ),
                  _vm._l(7, function(i) {
                    return _c(
                      "el-form-item",
                      { key: i, attrs: { "label-width": "0" } },
                      [
                        _c("cargo-input", {
                          ref: "consigneeLine" + i,
                          refInFor: true,
                          attrs: {
                            no: "consigneeLine" + i,
                            "auto-uppercase":
                              _vm.notUppercaseShipperConsigneNotify
                          },
                          on: {
                            change: function() {
                              return _vm.wrapAddr(
                                _vm.form,
                                "consigneeLine" + i,
                                i + 1 > 6 ? null : "consigneeLine" + (i + 1),
                                ""
                              )
                            }
                          },
                          nativeOn: {
                            dblclick: function($event) {
                              _vm.showAdvanceTextDialog(
                                _vm.$t("SeaExport.Consignee"),
                                _vm.mergeConsigneeLine(),
                                _vm.splitConsigneeLine,
                                _vm.notUppercaseShipperConsigneNotify,
                                null
                              )
                            }
                          },
                          model: {
                            value: _vm.form["consigneeLine" + i],
                            callback: function($$v) {
                              _vm.$set(_vm.form, "consigneeLine" + i, $$v)
                            },
                            expression: "form['consigneeLine'+i]"
                          }
                        })
                      ],
                      1
                    )
                  })
                ],
                2
              ),
              _c(
                "el-form",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.elementDict.notify.viewable,
                      expression: "elementDict.notify.viewable"
                    }
                  ],
                  staticStyle: { "margin-right": "10px" },
                  attrs: {
                    slot: "notify",
                    disabled: _vm.readonly || !_vm.elementDict.notify.writable,
                    "label-width": "50px",
                    "label-position": "right"
                  },
                  slot: "notify"
                },
                [
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "template",
                        { slot: "label" },
                        [
                          _c("line-label", {
                            class: _vm.elementDict.notify.isRequire
                              ? "blue"
                              : "",
                            attrs: { label: _vm.elementDict.notify.label }
                          }),
                          _c("char-count", {
                            staticStyle: {
                              position: "static",
                              display: "block",
                              "font-size": "10px",
                              color: "#909399"
                            },
                            attrs: { form: _vm.form, prefix: "notify" }
                          })
                        ],
                        1
                      ),
                      _c("cargo-company-select", {
                        staticStyle: {
                          display: "inline-block",
                          width: "175px"
                        },
                        attrs: {
                          no: "notifyId",
                          "method-params": {
                            notify: true,
                            active: true,
                            companyLob: "integratedJob"
                          },
                          "default-value": _vm.form.notifyId || ""
                        },
                        on: {
                          change: function(data) {
                            _vm.pm.notifyChange(data)
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          attrs: { no: "noconifyBillAddress", type: "primary" },
                          on: {
                            click: function($event) {
                              _vm.billAddressDialog.visible = true
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("SeaExport.CodeSearching")))]
                      )
                    ],
                    2
                  ),
                  _vm._l(7, function(i) {
                    return _c(
                      "el-form-item",
                      { key: i, attrs: { "label-width": "0" } },
                      [
                        _c("cargo-input", {
                          ref: "notifyLine" + i,
                          refInFor: true,
                          attrs: {
                            no: "notifyLine" + i,
                            "auto-uppercase":
                              _vm.notUppercaseShipperConsigneNotify
                          },
                          on: {
                            change: function() {
                              return _vm.wrapAddr(
                                _vm.form,
                                "notifyLine" + i,
                                i + 1 > 6 ? null : "notifyLine" + (i + 1),
                                ""
                              )
                            }
                          },
                          nativeOn: {
                            dblclick: function($event) {
                              _vm.showAdvanceTextDialog(
                                _vm.$t("SeaExport.NotifyParty"),
                                _vm.mergeNotifyLine(),
                                _vm.splitNotifyLine,
                                _vm.notUppercaseShipperConsigneNotify,
                                null
                              )
                            }
                          },
                          model: {
                            value: _vm.form["notifyLine" + i],
                            callback: function($$v) {
                              _vm.$set(_vm.form, "notifyLine" + i, $$v)
                            },
                            expression: "form['notifyLine'+i]"
                          }
                        })
                      ],
                      1
                    )
                  })
                ],
                2
              ),
              _vm.elementDict.alsoNotify.viewable
                ? _c(
                    "div",
                    { attrs: { slot: "alsoNotify" }, slot: "alsoNotify" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.alsoNotify.isRequire
                          ? "blue"
                          : "",
                        staticStyle: {
                          display: "inline-block",
                          "line-height": "28px",
                          "padding-bottom": "5px"
                        },
                        attrs: { label: _vm.elementDict.alsoNotify.label }
                      }),
                      _c("br"),
                      _c("cargo-rich-textarea", {
                        staticStyle: { width: "310px", height: "230px" },
                        attrs: {
                          disabled:
                            _vm.readonly ||
                            !_vm.elementDict.alsoNotify.writable,
                          no: "alsoNotify",
                          "text-chars": 0
                        },
                        nativeOn: {
                          dblclick: function($event) {
                            _vm.showAdvanceTextDialog(
                              _vm.$t("SeaExport.SecondNotifyParty"),
                              _vm.form.alsoNotify,
                              function(val) {
                                _vm.form.alsoNotify = val
                              },
                              _vm.notUppercaseShipperConsigneNotify,
                              null
                            )
                          }
                        },
                        model: {
                          value: _vm.form.alsoNotify,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "alsoNotify", $$v)
                          },
                          expression: "form.alsoNotify"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e()
            ],
            2
          )
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          attrs: {
            no: "ContactPerson",
            visible: _vm.contactDialog.visible,
            title: _vm.$t("SeaExport.ContactPerson"),
            width: "400px",
            "append-to-body": "",
            "close-on-click-modal": false,
            "close-on-press-escape": false
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.contactDialog, "visible", $event)
            }
          }
        },
        [
          _c(
            "el-form",
            { attrs: { "label-position": "right", "label-width": "100px" } },
            [
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("SeaExport.ContactPerson") + "：" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "170px" },
                    attrs: {
                      disabled: true,
                      value: _vm.contactDialog.data.contactPerson
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("SeaExport.Role") + "：" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "170px" },
                    attrs: {
                      disabled: true,
                      value: _vm.contactDialog.data.role
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("SeaExport.Tel") + "：" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "170px" },
                    attrs: {
                      disabled: true,
                      value: _vm.contactDialog.data.telephone
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("SeaExport.Mobile") + "：" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "170px" },
                    attrs: {
                      disabled: true,
                      value: _vm.contactDialog.data.mobile
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("SeaExport.Fax") + "：" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "170px" },
                    attrs: { disabled: true, value: _vm.contactDialog.data.fax }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("SeaExport.Email") + "：" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "170px" },
                    attrs: {
                      disabled: true,
                      value: _vm.contactDialog.data.email
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("CargoMsg.Cargo_Remarks") + "：" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "170px" },
                    attrs: {
                      disabled: true,
                      value: _vm.contactDialog.data.remarks,
                      type: "textarea",
                      rows: 3
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          attrs: {
            no: "advanceTextDialog",
            visible: _vm.advanceTextDialog.visible,
            title: _vm.advanceTextDialog.title,
            width: "600px",
            "close-on-click-modal": false,
            "close-on-press-escape": false
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.advanceTextDialog, "visible", $event)
            }
          }
        },
        [
          _c("cargo-rich-textarea", {
            ref: "advanceTextDialogTextarea",
            staticStyle: { height: "198px" },
            attrs: {
              no: "advanceTextDialogTextarea",
              disabled: _vm.readonly,
              "text-chars": _vm.advanceTextDialog.formatObj.maxChar,
              "warning-count": _vm.advanceTextDialog.formatObj.warningCount,
              "auto-half-word": _vm.advanceTextDialog.formatObj.autoHalfWord,
              "auto-uppercase": _vm.advanceTextDialog.formatObj.autoUppercase
            },
            model: {
              value: _vm.advanceTextDialog.value,
              callback: function($$v) {
                _vm.$set(_vm.advanceTextDialog, "value", $$v)
              },
              expression: "advanceTextDialog.value"
            }
          }),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.isEdit,
                      expression: "isEdit"
                    }
                  ],
                  attrs: { no: "advanceTextDialogConfirm", type: "primary" },
                  on: { click: _vm.finishAdvanceText }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.confirm")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { no: "advanceTextDialogClose" },
                  on: {
                    click: function($event) {
                      _vm.advanceTextDialog.visible = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.close")))]
              )
            ],
            1
          )
        ],
        1
      ),
      _c("sop-dialog", {
        attrs: {
          visible: _vm.sopDialog.visible,
          "cmp-idx": _vm.sopDialog.cmpIdx,
          job: _vm.form,
          agent: _vm.sopDialog.agent,
          lob: "IE",
          "contact-list": _vm.sopDialog.contactList
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.sopDialog, "visible", $event)
          },
          updateJob: function($event) {
            return _vm.$emit("updateJob")
          }
        }
      }),
      _c("transcribe-dialog", {
        attrs: { visible: _vm.transcribeDialog.visible, job: _vm.form },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.transcribeDialog, "visible", $event)
          },
          callback: _vm.transcribeCallback
        }
      }),
      _c("hs-code-search-dialog", {
        attrs: {
          visible: _vm.hsCodeSearchDialog.visible,
          title: _vm.hsCodeSearchDialog.title
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.hsCodeSearchDialog, "visible", $event)
          },
          callback: _vm.hsCodeSearchDialog.successCallback
        }
      }),
      _c("select-operation-req-dialog", {
        attrs: {
          visible: _vm.selectOperationReqDialog.visible,
          lob: "IE",
          value: _vm.selectOperationReqDialog.value
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.selectOperationReqDialog, "visible", $event)
          },
          callback: function(val) {
            return (_vm.form.operationContent = val)
          }
        }
      }),
      _c("bill-address-dialog", {
        attrs: { visible: _vm.billAddressDialog.visible, job: _vm.form },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.billAddressDialog, "visible", $event)
          },
          callback: _vm.codeSearchCallback
        }
      }),
      _c("stamp-picture-view", {
        attrs: {
          visible: _vm.stampPictureView.visible,
          "business-documents": _vm.stampPictureView.businessDocuments
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.stampPictureView, "visible", $event)
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }